// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useState, useRef, useEffect, useCallback ,useMemo} from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';  // Import useNavigate for navigation
import { faShare,faQuestionCircle, faExclamationTriangle, faCopy,faFileExport, faSave, faCircleCheck,faEyeSlash, faMessage, faChartColumn,faCaretDown , faPenToSquare, faCheck, faGlobe ,faCircleNodes,faVideo,faGripVertical,faRobot,faRectangleXmark,faBell, faTrash , faRefresh ,faFileExcel,faClone,faChevronLeft, faCircleInfo    } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvancedUISettings from '../pages/AdvancedUISettings';
import AdvancedAISettings from '../pages/AdvancedAISettings'; 
import AddFromPromptLibrary from '../pages/AddFromPromptLibrary';   
import PromptPreview from '../pages/PromptPreview';  
import PublicWebsites from '../pages/publicwebsite/PublicWebsites'; 
import CanvasCourse from '../pages/canvas/CanvasCourse'; 
import Panopto from './panopto/PanoptoFolder';
import CalenderSchedule from '../pages/CalenderSchedule';
import FileUploader from '../pages/cusomfileupload/FileUploader';
import ChatHistory from '../pages/chathistory/ChatHistory';
import UsageMetrics from '../pages/usagemetrics/UsageMetrics';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { publishVirtualAssistant, unpublishVirtualAssistant, cloneVirtualAssistant, deleteVirtualAssistant, getAssistantById, saveAssistant,updateAssistant, uploadFile, exportVirtualAssistant,generateTokenAPI } from '../services/api/virtualAssistant';
import { logger } from '../services/utilities/logger';
import { getSafeImageSrc } from '../utils/imageUtils';
import { useUISettings } from '../hooks/useUISettings';
import { useAISettings } from '../hooks/useAISettings';
 
import { useDropzone } from "react-dropzone";
import AuthenticationSettings from './AuthenticationSettings';
import { CourseData, ExcludedItems, WebsiteData,WebsiteItems } from '../types/CourseData';
import { SharePointData, ExcludedItems as SharePointExcludedItems } from '../types/sharepoint.types';
import CustomModal from "../components/CustomModal";
import { CanvasUser } from '../types/CanvasUser';

import {  FolderData } from "../types/PanoptoData";
import { User } from "../types/assistant";
import CoOwnerModal from "../components/CoOwnerModal";
import SharePoint from './sharepoint/SharePoint';
import ModelRetirementBanner from '../components/ModelRetirementBanner';
import { fetchModelRetirementConfig, ModelRetirementConfig } from '../services/api/commonData';

// 2. ADD MISSING IMPORT - Add this import at the top with other imports:
import { sharepointTabConfig } from '../constants/sharepointTabConfig';
interface SystemConfig {
  Id: string;
  ConfigValue: string;
}

type VisibilityKey = 'announcements' | 'assignments' | 'discussions' | 'files' | 'modules' | 'pages' | 'enrollments' | 'quizzes' | 'syllabus';

interface UploadedFile {
  file: File;
  id: string;
  status: 'uploading' | 'completed' | 'error';
  progress: number;
  file_name: string;
  size: number;
  error: string | null;
  location: string | null;
  sequence: string | '1';
  file_type: string | null;
  file_extn: string | null;
  file_url?: string | null; 
  file_unique_id?: string | null;
}
  
interface CalenderFile {
  file: File;
  id: string;
  status: 'uploading' | 'completed' | 'error';
  progress: number;
  file_name: string;
  size: number;
  error: string | null;
  location: string | null;
  sequence: string | '1';
  file_type: string | null;
  file_extn: string | null;
  file_url?: string | null; 
}

interface CourseIdentifier {
  course_id: string;
  course_url?: string;
}
 
const BuildNewAssistant = () => {

  const [bypasstoken, setBypasstoken] = useState('');

  const VA_URL = process.env.REACT_APP_VA_APP_URL;
  // console.log(VA_URL)
  useEffect(() => {
    const getDynamicDummyUser = () => {
      const now = new Date();
      const formattedDate = now
        .toISOString()
        .replace(/[-T:]/g, '')
        .split('.')[0];
      
      return `previewuser_${formattedDate}`;
    }
    
    // Usage inside your React component
    const dummyUser = getDynamicDummyUser();
    const key = 'VAB25J040312';
    const generateToken = async () => {
      // const net_id = 'authorized_user';
      const result = await generateTokenAPI(dummyUser || '', key);
      if(result.bypass_token){
        setBypasstoken(result.bypass_token);
      }
      // console.log(result);
    }
    generateToken();
    },[]);
 
    const getUserName = () => {
        return localStorage.getItem('fullName');
    };
    const location = useLocation();
    const navigate = useNavigate();
    const { appId: urlAppId } = useParams<{ appId: string }>(); // Get appId from URL params

    // State for URL-based loading
    const [urlLoadError, setUrlLoadError] = useState<string | null>(null);
    const [isLoadingFromUrl, setIsLoadingFromUrl] = useState<boolean>(!!urlAppId && !location.state?.assistant);

    // const initialAssistant = location.state?.assistant || {}; // Ensure assistant is at least an empty object
    const [assistant, setAssistant] = useState<Record<string, any>>(location.state?.assistant || {});
    // Add this state to store the safe image source

    // Effect to load VA from URL param if no state is passed
    useEffect(() => {
      const loadVAFromUrl = async () => {
        // Only load from URL if:
        // 1. We have a URL param (urlAppId)
        // 2. No assistant data was passed via state
        // 3. We haven't already loaded the assistant
        if (urlAppId && !location.state?.assistant && !assistant?.app_id) {
          setIsLoadingFromUrl(true);
          setUrlLoadError(null);

          const netId = localStorage.getItem("netId") || undefined;

          try {
            const data = await getAssistantById(urlAppId!, netId);
            if (data) {
              setAssistant(data);
              setIsLoadingFromUrl(false);
            }
          } catch (error: any) {
            setIsLoadingFromUrl(false);
            if (error.status === 403) {
              setUrlLoadError('You do not have permission to access this Virtual Assistant.');
            } else if (error.status === 404) {
              setUrlLoadError('Virtual Assistant not found.');
            } else {
              setUrlLoadError('Failed to load Virtual Assistant. Please try again.');
            }
          }
        } else {
          setIsLoadingFromUrl(false);
        }
      };

      loadVAFromUrl();
    }, [urlAppId, location.state?.assistant]);

    const [isInitialLoadDone, setIsInitialLoadDone] = useState(() => {
      const initialAssistant = assistant?.app_id || '';
      return !initialAssistant.app_id; // ✅ true if app_id is empty
    });

    const [systemConfig, setSystemConfig] = useState<SystemConfig[]>([]);
    useEffect(() => {
      const getCachedData = (key: string) => {
        const item = sessionStorage.getItem(key);
        if (!item) return null;
        const { value, timestamp } = JSON.parse(item);
        if (Date.now() - timestamp >2 * 24 * 60 * 60 * 1000) { // 30 minutes cache
          sessionStorage.removeItem(key);
          return null;
        }
        return value;
      };

      const config = getCachedData('systemConfig');
      if (config) {
        setSystemConfig(config);
      }
    }, []);

    const [iframeSrc, setIframeSrc] = useState<string>("");
     const [isCoOwnerModalOpen, setIsCoOwnerModalOpen] = useState(false);
     const [selectedAppId, setSelectedAppId] = useState<string>('');
     const [selectedCoOwners, setSelectedCoOwners] = useState<User[]>([]);
     const [isCurrentUserCoOwner, setIsCurrentUserCoOwner] = useState(false);
     
     useEffect(() => {
      
    }, [selectedAppId]);

    const [logedInNetid,setLogedInNetId] = useState<string>("");
    useEffect(() => {


    },[logedInNetid]);
    useEffect(() => {
      const loginUserNetid = localStorage.getItem("netId") || '';
      setLogedInNetId(loginUserNetid)
      // Dynamically generate the iframe source
      const storedInferenceURL = localStorage.getItem("inference_url");
      var coping_inference_url = storedInferenceURL + assistant?.id;
  
      setIframeSrc(coping_inference_url);
    }, []);


  

    const iframeEmbedCode = `<iframe id="iframe" src="${iframeSrc}" width="600" height="720"  sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation">\n</iframe>`;
    const jsEmbedCode = `<script src="${localStorage.getItem("inference_url")}widget.js" data-app-id="${assistant?.id}" data-button-color="#4e2a84" data-position="bottom-right" data-width="500" data-height="520">\n</script>`;
    const [appPublishStatus, setAppPublishStatus] = useState("UNPUBLISHED");
    
    // Advanced UI Settings states
    const { bgColor, setBgColor,
        fontColor, setFontColor,
        iconColor, setIconColor,
        headerColor, setHeaderColor,
        logo, setLogo,
        isShowHeader, setIsShowHeader,
    } = useUISettings(assistant);

    const {
        temperature, setTemperature,
        maximumLength,setMaximumLength,
        stopSequences,setStopSequences,
        topP,setTopP,
        fPenalty,setFPenalty,
        pPenalty,setPPenalty,
        isAIModalOpen,setIsAIModalOpen,
        modal,setModal,
        aiModels, // Get this from the hook
        temperatureConfig,
       
    } = useAISettings(assistant); // Use the hook

    // Model Retirement Banner State
    const [modelRetirementConfigs, setModelRetirementConfigs] = useState<ModelRetirementConfig[]>([]);
    const [currentModelRetirement, setCurrentModelRetirement] = useState<ModelRetirementConfig | null>(null);
    const [showRetirementBanner, setShowRetirementBanner] = useState(false);
    const [isUpgradingModel, setIsUpgradingModel] = useState(false);

    // Fetch model retirement configurations on mount
    useEffect(() => {
        const loadRetirementConfig = async () => {
            const configs = await fetchModelRetirementConfig();
            setModelRetirementConfigs(configs);
        };
        loadRetirementConfig();
    }, []);

    // Check if current model is in retirement when modal (model) or configs change
    useEffect(() => {
        if (modal && modelRetirementConfigs.length > 0) {
            const retirementInfo = modelRetirementConfigs.find(
                config => config.model_value === modal &&
                (config.status === 'retiring' || config.status === 'deprecated')
            );
            if (retirementInfo) {
                setCurrentModelRetirement(retirementInfo);
                setShowRetirementBanner(true);
            } else {
                setCurrentModelRetirement(null);
                setShowRetirementBanner(false);
            }
        }
    }, [modal, modelRetirementConfigs]);

    const maximumLengthConfig = { min: 50, max: 128000, steps: 50 };
    const topPConfig = { min: 0.0, max: 1.0, steps: 0.1 };
    const fPenaltyConfig = { min: 0.0, max: 2.0, steps: 0.1 };
    const pPenaltyConfig = { min: 0.0, max: 2.0, steps: 0.1 };
    const [isUIModalOpen, setIsUIModalOpen] = useState(false);
    const advancedUIModal = () => setIsUIModalOpen(!isUIModalOpen);
    const advancedAIModal = () => setIsAIModalOpen(!isAIModalOpen);
    const [height, setHeight] = useState(window.innerHeight);

    //generate iframe value
   
  // useEffect(() => {
  //   const updateHeight = () => setHeight(window.innerHeight);
  //   window.addEventListener("resize", updateHeight);
  //   return () => window.removeEventListener("resize", updateHeight);
  // }, []);

    //public websites
    
    const [isCanvasRNightly, setIsCanvasRNightly] = useState(false);
    const [isPanoptoRNightly, setIsPanoptoRNightly] = useState(false);
    const [isCustomFileRNightly, setIsCustomFileRNightly] = useState(false);

    const [isWebsiteFullLoad, setIsWebsiteFullLoad] = useState(false);
    const [isCanvasFullLoad, setIsCanvasFullLoad] = useState(false);
    const [isPanoptoFullLoad, setIsPanoptoFullLoad] = useState(false);
    const [isCustomFileFullLoad, setIsCustomFileFullLoad] = useState(false);

    const getUserEmail = () => {
      
    return localStorage.getItem('netId') + '@ads.northwestern.edu';
  };
    const [isMetricsEmail, setMetricsEmail] = useState(false);
    const [metricsEmailAddress, setMetricsEmailAddress] = useState(getUserEmail);
    // const handleWebsitesChange = (updatedWebsites: { url: string; label: string }[]) => {
    //   // setWebsites(updatedWebsites);
    //   console.log('Updated Websites in BuildNewAssistant:', updatedWebsites);
    // };
    // const [websites, setWebsites] = useState<{ url: string; label: string }[]>(
    //     assistant?.data_public_websites?.websites?.map((site: any) => ({
    //         url: site.website_url,
    //         label: site.website_name
    //     })) || []
    // );
    //setup canvas courses
    const [courses, setCourses] = useState<CourseData[]>(() => {
      return assistant?.id 
        ? [] // Empty array when editing an existing assistant
        : [{
            id: 1,
            url: 'https://canvas.northwestern.edu/courses/',
            tenant: '',
            order: 1,
            activeTab: 'CONNECT',
            connectionState: 'idle',
            course_id: '',
            course_name: 'New Canvas Course 1',
            selectedItems: {
              announcements: false,
              assignments: false,
              discussions: false,
              files: false,
              modules: false,
              pages: false,
              enrollments: false,
              groups: false,
              quizzes: false,
              syllabus: false,
            },
            courseItems: {
              announcements: [],
              assignments: [],
              discussions: [],
              files: [],
              modules: [],
              pages: [],
              enrollments: [],
              groups: [],
              quizzes: [],
              syllabus: [],
            },
            excludedItems: {
              excluded_assignments: [],
              excluded_announcements: [],
              excluded_discussions: [],
              excluded_files: [],
              excluded_modules: [],
              excluded_pages: [],
              excluded_enrollments: [],
              excluded_quizzes: [],
              excluded_syllabus: []
            },
            isLoadingItems: false,
            error: undefined,
            visibility: {
              announcements: true,
              assignments: true,
              discussions: true,
              files: true,
              modules: true,
              pages: true,
              enrollments: true,
              quizzes: true,
              syllabus: true,
            },
          }];
    });
       
    const handleToggleChange = (key: VisibilityKey, courseId: number) => {
      setCourses((prevCourses) => {
        const updatedCourses = prevCourses.map((course) => {
          if (course.id === courseId) {
            
            // Toggle the visibility
            const updatedVisibility = {
              ...course.visibility,
              [key]: !course.visibility[key], // Toggle visibility
            };
    
            // console.log("Updated visibility for tab:", updatedVisibility)
            // return [...prevCourses, ...updatedVisibility
            return {
              ...course,
              visibility: updatedVisibility,
            };
          }
          return course;
        });
    
        // console.log("After updating state:");
        // console.log("Updated courses:", updatedCourses); // Log the updated courses' visibility after update
        setHasChanges(true);
        return updatedCourses;
      });
    };

 const handleSharePointToggleChange = (key: 'lists' | 'document_libraries', sharepointId: number) => {
  console.log('🟢 BuildNewAssistant handleSharePointToggleChange:', { key, sharepointId });
  
  setSharepoints((prevSharepoints) => {
    console.log('🟢 BEFORE toggle - prevSharepoints:', prevSharepoints.length);
    
    const updatedSharepoints = prevSharepoints.map((sharepoint) => {
      if (sharepoint.id === sharepointId) {
        console.log('🟢 Found sharepoint to update:', sharepoint.id);
        console.log('🟢 Current visibility:', sharepoint.visibility);
        
        // SAFETY CHECK: Initialize visibility if it doesn't exist
        const currentVisibility = sharepoint.visibility || {
          lists: true,
          document_libraries: true,
        };

        const updatedVisibility = {
          ...currentVisibility,
          [key]: !currentVisibility[key],
        };

        console.log('🟢 Updated visibility:', updatedVisibility);

        return {
          ...sharepoint,
          visibility: updatedVisibility,
        };
      }
      return sharepoint;
    });

    console.log('🟢 AFTER toggle - updatedSharepoints:', updatedSharepoints.length);
    setHasChanges(true);
    return updatedSharepoints;
  });
};
    
    const updateExcludedItems = (
      courseId: number,
      type: keyof ExcludedItems,  // Ensure 'type' is a valid key of ExcludedItems
      itemId: string
    ) => {
      setCourses((prevCourses) =>
        prevCourses.map((course) =>
          course.id === courseId
            ? {
                ...course,
                excludedItems: {
                  ...course.excludedItems,
                  [type]: course.excludedItems[type]?.includes(itemId)
                    ? course.excludedItems[type].filter((id) => id !== itemId)
                    : [...course.excludedItems[type], itemId],
                },
              }
            : course
        )
      );
    };
    
    const handleCanvasCourse = () => setCanvasCourseModalOpen(!isCanvasCourseModalOpen);
    const [isCanvasCourseModalOpen, setCanvasCourseModalOpen] = useState(false);
    const [canvasCourses, setCanvasCourses] = useState<CourseData[]>([]);
      
    // for chat history
    const handleChatHistory = () => setIsChatHistoryModalOpen(!isChatHistoryModalOpen);
    const [isChatHistoryModalOpen, setIsChatHistoryModalOpen] = useState(false);

    //for usage metrics
    const handleUsageMetrics = () => setIsUsageMetricsModalOpen(!isUsageMetricsModalOpen);
    const [isUsageMetricsModalOpen, setIsUsageMetricsModalOpen] = useState(false);

    //for custom modal
    const [customModal, setCustomModal] = useState<{
        isOpen: boolean;
        title: string;
        message: string;
        type: "success" | "error" | "loading" | "confirmation" | "warning";
        onConfirm?: () => void;
      }>({
        isOpen: false,
        title: "",
        message: "",
        type: "confirmation", // Default type
      });
      const showCustomModal = (title: string, message: string, type: "success" | "error" | "loading" | "confirmation", onConfirm?: () => void) => {
        setCustomModal({
          isOpen: true,
          title,
          message,
          type,
          onConfirm,
        });
      };
    
      // Function to show the confirmation modal
      const showConfirmationModal = (message: string, onConfirm: () => void) => {
        setCustomModal({
          isOpen: true,
          title: appPublishStatus === "PUBLISHED" ? "Unpublish Confirmation" : "Publish Confirmation",
          message,
          type: "confirmation",
          onConfirm, // Passing the onConfirm function
        });
      };
      const showDeleteConfirmationModal = (message: string, onConfirm: () => void) => {
        setCustomModal({
          isOpen: true,
          title: "Delete Confirmation",
          message,
          type: "confirmation",
          onConfirm, // Passing the onConfirm function
        });
      };
      const showCloneConfirmationModal = (message: string, onConfirm: () => void) => {
        setCustomModal({
          isOpen: true,
          title: "Clone Confirmation",
          message,
          type: "confirmation",
          onConfirm, // Passing the onConfirm function
        });
      };
      const showExportConfirmationModal = (message: string, onConfirm: () => void) => {
        setCustomModal({
          isOpen: true,
          title: "Export Confirmation",
          message,
          type: "confirmation",
          onConfirm, // Passing the onConfirm function
        });
      };
      
      
      const handleCalender= () => setCalenderModalOpen(!isCalenderModalOpen);
      const [isCalenderModalOpen, setCalenderModalOpen] = useState(false);

    //setup panopto
    
    const handlePanopto = () => setPanoptoModalOpen(!isPanoptoModalOpen);
    const [isPanoptoModalOpen, setPanoptoModalOpen] = useState(false);

    const [panoptos, setPanoptos] = useState<FolderData[]>([
        { 
          id: 1, 
          url: '', 
          order: 1, 
          activeTab: 'CONNECT', 
          connectionState: 'idle',
          panopto_id:'',
          panopto_name:'New Panopto Folder 1',
          excludedItems: [],
          panoptoItems: {
            files: [],   // Initialize as empty array
          },
          isLoadingItems: false,
          error: undefined,

        }
      ]);
      const lastExcludedItemsRef = useRef<{ [key: number]: string[] }>({});

      const updatePanoptoExcludedItems = (folderId: number, uncheckedIds: string[]) => {
        setPanoptos((prevPanoptos) => {
          let hasChanges = false;
      
          const updatedPanoptos = prevPanoptos.map((folder) => {
            if (folder.id === folderId) {
              // Sort both arrays for accurate comparison (order-independent)
              const currentExcluded = [...(folder.excludedItems || [])].sort();
              const newExcluded = [...uncheckedIds].sort();
      
              // Check if there are actual changes
              const isSame =
                currentExcluded.length === newExcluded.length &&
                currentExcluded.every((id, index) => id === newExcluded[index]);
      
              if (isSame) {
                return folder; // No changes, prevent state update & re-render
              }
      
              // Store the last known excluded items to prevent redundant updates
              lastExcludedItemsRef.current[folderId] = newExcluded;
              hasChanges = true;
      
              return { ...folder, excludedItems: newExcluded }; // Update only if changes exist
            }
            return folder;
          });
      
          // Trigger auto-save if there are actual changes
          if (hasChanges) {
            if(isInitialLoadDone)
              setHasChanges(true); 
          }
      
          return updatedPanoptos;
        });
      };

      //this is for panopto on uncheck 
      const uncheckedItemIds = (
        courseId: number,
        type: keyof ExcludedItems,  // Ensure 'type' is a valid key of ExcludedItems
        itemId: string
      ) => {
        setCourses((prevCourses) =>
          prevCourses.map((course) =>
            course.id === courseId
              ? {
                  ...course,
                  excludedItems: {
                    ...course.excludedItems,
                    [type]: course.excludedItems[type]?.includes(itemId)
                      ? course.excludedItems[type].filter((id) => id !== itemId)
                      : [...course.excludedItems[type], itemId],
                  },
                }
              : course
          )
        );
      }; 
    
    // Access the user from the AuthContext
    const clonedAssistant = location.state?.assistant;

    useEffect(() => {
      // console.log("Received Cloned Assistant:", clonedAssistant);
      if(clonedAssistant){
        setAssistant(clonedAssistant);
        assistant.app_id = clonedAssistant?.app_id;
      }
    }, [clonedAssistant]);

    const [includeCommonKnowledge, setIncludeCommonKnowledge] = useState<boolean>(false);
    const [hasClickedCommonKnowledge, setHasClickedCommonKnowledge] = useState(false);
    const hasUserToggledCommonKnowledgeRef = useRef(false);

    // User File Upload and Speech to Text toggles (enabled by default)
    const [isUserFileUploadEnabled, setIsUserFileUploadEnabled] = useState<boolean>(true);
    const [isSpeechToTextEnabled, setIsSpeechToTextEnabled] = useState<boolean>(true);


    const handleCommonKnowledge = () => {
      hasUserToggledCommonKnowledgeRef.current = true;
      setIncludeCommonKnowledge(prev => !prev);
      setHasClickedCommonKnowledge(true);
      if (isInitialLoadDone) {
        setHasChanges(true);
      }
    };

    useEffect(() => {
      if (hasUserToggledCommonKnowledgeRef.current && isInitialLoadDone) {
        setHasChanges(true);
        autoSave(); // This runs AFTER includeCommonKnowledge has updated
        hasUserToggledCommonKnowledgeRef.current = false;
      }
    }, [includeCommonKnowledge]);

    useEffect(() => {

    },[hasClickedCommonKnowledge]);

    // Handle back button click
    const handleBackClick = () => {
        navigate('/');  // This will navigate back to the previous page
    };

    // Handle model upgrade from retirement banner
    const handleModelUpgrade = async (replacementModel: string) => {
        setIsUpgradingModel(true);
        try {
            // Update the model
            setModal(replacementModel);

            // Mark as changed to trigger auto-save
            setHasChanges(true);

            // Hide the banner
            setShowRetirementBanner(false);
            setCurrentModelRetirement(null);

            // Show success message
            Swal.fire({
                icon: 'success',
                title: 'Model Upgraded',
                text: `Successfully upgraded to ${replacementModel}. Changes will be saved automatically.`,
                timer: 3000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Error upgrading model:', error);
            Swal.fire({
                icon: 'error',
                title: 'Upgrade Failed',
                text: 'Failed to upgrade model. Please try again.',
            });
        } finally {
            setIsUpgradingModel(false);
        }
    };

    // Handle dismiss retirement banner
    const handleDismissRetirementBanner = () => {
        setShowRetirementBanner(false);
    };

    const handlePublishAssistant = async () => {
        setIsPublishOperationInProgress(true); // Block autosave during publish

        // First check if at least one knowledge source is present
        // const hasPublicWebsites = Array.isArray(websites) && websites.length > 0;
        // const hasCanvasCourses = Array.isArray(canvasCourses) && canvasCourses.length > 0;
        // const hasPanopto = Array.isArray(panoptos) && panoptos.length > 0;
        // const hasUploadedFiles = Array.isArray(selectedFiles) && selectedFiles.length > 0;

        // const FilteredFileData = getFilteredFileData();
        
        // const connectedPanopto = panoptos?.filter(p => p.connectionState === "connected") || [];
    
        // const connectedWebsites = getFilteredWebsiteData().filter(p => p.connectionState === "connected") || [];
    
        // const connectedCanvas = getFilteredCanvasData().filter(p => p.connectionState === "connected") || [];
        
        // // If all knowledge sources are empty, show error and return
        
        // if (
        //   connectedWebsites.length === 0 &&
        //   connectedCanvas.length === 0 &&
        //   connectedPanopto.length === 0 &&
        //   FilteredFileData.length === 0
        // ) {
        //   setCustomModal({
        //     isOpen: true,
        //     title: "Validation Error",
        //     message: "Please add at least one knowledge source (Public Websites, Canvas Course, Panopto, or Upload Files)",
        //     type: "error", // Display loader
        //   });
        //   return;
        // }
        // else{
    
        // Show confirmation modal
        showConfirmationModal("Do you want to publish this chatbot?", async () => {
          // console.log("Confirm button clicked");
    
          // Close confirmation modal
          setCustomModal((prev) => ({
            ...prev,
            isOpen: false,
          }));
    
          // Show loading modal
          setCustomModal({
            isOpen: true,
            title: "Publishing...",
            message: "Please wait while we publish your chatbot.",
            type: "loading", // Display loader
          });
    
          try {
            // Simulate API call
            const [ responseData ] = await Promise.all([
                publishVirtualAssistant(assistant?.app_id).catch(() => ({ data: [] })),
            ]);
            // console.log("API response", responseData);
    
            if (responseData?.app_publishstatus === "Published") {
              setAppPublishStatus("PUBLISHED");
              setCustomModal({
                isOpen: true,
                title: "Success!",
                message: "Your chatbot has been published.",
                type: "success",
              });
            } else {
              let msg = 'There was an issue publishing the chatbot.';
              if(responseData?.hasError){
                msg = responseData?.errorMessage
                setCustomModal({
                  isOpen: true,
                  title: "Warning!",
                  message: msg,
                  type: 'warning',
                });
              }
              else{
                setCustomModal({
                  isOpen: true,
                  title: "Error!",
                  message: msg,
                  type: 'error',
                });
              }

            }
            setIsPublishOperationInProgress(false); // Re-enable autosave
          } catch (error) {
            console.log("API call failed", error);
            setCustomModal({
              isOpen: true,
              title: "Error!",
              message: "There was an error with the request.",
              type: "error",
            });
            setIsPublishOperationInProgress(false); // Re-enable autosave on error
          }
        });
      // }
    };
  
    const handleunpublishAssistant = async () => {
        setIsPublishOperationInProgress(true); // Block autosave during unpublish
        showConfirmationModal("Do you want to unpublish this chatbot?", async () => {
            // console.log("Confirm button clicked");
      
            // Close confirmation modal
            setCustomModal((prev) => ({
              ...prev,
              isOpen: false,
            }));
      
            // Show loading modal
            setCustomModal({
              isOpen: true,
              title: "Unpublishing...",
              message: "Please wait while we unpublish your chatbot.",
              type: "loading", // Display loader
            });
    
            try {
                const [ responseData ] = await Promise.all([
                    unpublishVirtualAssistant(assistant?.app_id).catch(() => ({ data: [] })),
                ]);
                if (responseData?.app_publishstatus && responseData?.app_publishstatus == "UnPublished") {
                    setAppPublishStatus("UNPUBLISHED");
                    setCustomModal({
                    isOpen: true,
                    title: "Success!",
                    message: "Your chatbot has been unpublished.",
                    type: "success",
                    });
                } else {
                    setCustomModal({
                    isOpen: true,
                    title: "Error!",
                    message: "There was an issue unpublishing the assistant.",
                    type: "error",
                    });
                }
                setIsPublishOperationInProgress(false); // Re-enable autosave
            } catch (error) {
              console.log("API call failed", error);
              setCustomModal({
                isOpen: true,
                title: "Error!",
                message: "There was an error with the request.",
                type: "error",
              });
              setIsPublishOperationInProgress(false); // Re-enable autosave on error
            }
        });
    };
    
    //handle AI chat settings
    const app_ai_settings = assistant?.app_ai_settings || [];
    
    const [greetingSettings, setGreetingSettings] = useState({
      isChecked: true, // Explicit conversion from string
      text: ""
    });
    
    useEffect(() => {
      // console.log('Updated greetingSettings:', greetingSettings);
      // console.log('temperature greetingSettings:', temperature);
    }, [greetingSettings,temperature,maximumLength,stopSequences,topP,fPenalty,pPenalty,temperatureConfig ]);
    
    const handleGreetingSettingsChange = (key: string, value: any) => {
        setGreetingSettings((prev) => ({ ...prev, [key]: value }));
    };

    const handleShowGreeting = () => {
        handleGreetingSettingsChange("isChecked", !greetingSettings.isChecked);
        if(isInitialLoadDone)
          setHasChanges(true);
        
    };
    const [isStartersChecked, setStarterChecked] = useState<boolean>(
      false
    );
    
    const handleShowStarter = () => {
        setStarterChecked(prev => !prev); // Toggle between true and false
        if(isInitialLoadDone)
          setHasChanges(true);
    };

    //get all prompts value from sys config
    const [prompt1, setPrompt1Text] = useState<string>("");

    const prompt1TextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt1Text(event.target.value); // Update state when the user types
    };

    const [prompt2, setPrompt2Text] = useState<string>("");

    const prompt2TextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt2Text(event.target.value); // Update state when the user types
    };
    const [prompt3, setPrompt3Text] = useState<string>("");
    
    const prompt3TextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt3Text(event.target.value); // Update state when the user types
    };

    const [prompt4, setPrompt4Text] = useState<string>("");

    const prompt4TextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt4Text(event.target.value); // Update state when the user types
    };

    const [isPLibraryModalOpen, setIsPromptLibraryModalOpen] = useState(false);
    const advancedPromptLibraryModal = () => setIsPromptLibraryModalOpen(!isPLibraryModalOpen);

    const [isPPreviewModalOpen, setIsPromptPreviewModalOpen] = useState(false);
    const PromptPreviewModal = () => setIsPromptPreviewModalOpen(!isPPreviewModalOpen);
    
    const [instructions, setInstructions] = useState<string>(
      assistant?.instructions || "" 
    );

    const [crawlDepth, setCrawlDepth] = useState<string>('');

    const [tempInstructions, setTempInstructions] = React.useState(instructions);
    const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);


    const DEBOUNCE_DELAY = 1000;

    const handleTempChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setTempInstructions(e.target.value);
      
      // Clear existing timer
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      
      // Set new timer for auto-save
      debounceTimer.current = setTimeout(() => {
        // Auto-save logic - update main state and trigger save
        setInstructions(e.target.value);
        if (isInitialLoadDone) {
          setHasChanges(true);
        }
      }, DEBOUNCE_DELAY);
  };
    const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    
    // Update main state or perform action on blur
    handleInstructionsChange(e);
};

    const handleInstructionsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setInstructions(e.target.value);
      if(isInitialLoadDone)
        setHasChanges(true);
    };

    // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

    // Add these state variables with your other state declarations

const [sharepoints, setSharepoints] = useState<SharePointData[]>(() => {
  if (assistant?.id) {
    return [];
  }
  
  const initialSharePoint: SharePointData = {
    id: 1,
    sharepoint_id: '',
    url: 'https://nuwildcat.sharepoint.com',
    order: 1,
    sharepoint_name: 'SharePoint Source 1',
    activeTab: 'CONNECT',
    connectionState: 'idle',
    selectedItems: {
      lists: false,
      document_libraries: false,
    },
    excludedItems: {
  excluded_lists: [],
  excluded_document_libraries: [],
  partial_excluded_document_libraries: [], // ADD THIS LINE
},
    visibility: {
      lists: true,
      document_libraries: true,
    },
    sharepointItems: {
      lists: [],
      document_libraries: [],
    },
    isLoadingItems: false,
    error: undefined,
  };
  
  return [initialSharePoint];
});

const [isSharePointRNightly, setIsSharePointRNightly] = useState(false);
const [isSharePointFullLoad, setIsSharePointFullLoad] = useState(false);

// SharePoint modal state
const [isSharePointModalOpen, setSharePointModalOpen] = useState(false);

// SharePoint handler
const handleSharePoint = () => setSharePointModalOpen(!isSharePointModalOpen);

// SharePoint change handler
const handleSharePointChange = (setter: React.Dispatch<React.SetStateAction<any>>, value: any) => {
  setter(value);
};

// SharePoint excluded items handler
const updateSharePointExcludedItems = (
  sharepointId: number, 
  type: keyof SharePointExcludedItems, 
  itemId: string
) => {
  setSharepoints((prevSharepoints) => {
    const updatedSharepoints = prevSharepoints.map((sharepoint) => {
      if (sharepoint.id === sharepointId) {
        // Handle simple list exclusions (unchanged)
        if (type === 'excluded_lists') {
          const currentExcluded = sharepoint.excludedItems[type] || [];
          const newExcluded = currentExcluded.includes(itemId)
            ? currentExcluded.filter(id => id !== itemId)
            : [...currentExcluded, itemId];

          return {
            ...sharepoint,
            excludedItems: {
              ...sharepoint.excludedItems,
              [type]: newExcluded
            }
          };
        }

        // Handle document library exclusions (new logic)
        if (type === 'excluded_document_libraries') {
          const currentExcluded = sharepoint.excludedItems[type] || [];
          const newExcluded = currentExcluded.includes(itemId)
            ? currentExcluded.filter(id => id !== itemId)
            : [...currentExcluded, itemId];

          // When adding/removing from excluded_document_libraries,
          // also clean up partial_excluded_document_libraries
          const updatedPartialExcluded = (sharepoint.excludedItems.partial_excluded_document_libraries || [])
            .filter(lib => lib.lib_id !== itemId);

          return {
            ...sharepoint,
            excludedItems: {
              ...sharepoint.excludedItems,
              excluded_document_libraries: newExcluded,
              partial_excluded_document_libraries: updatedPartialExcluded
            }
          };
        }
      }
      return sharepoint;
    });

    if (isInitialLoadDone) {
      setHasChanges(true);
    }

    return updatedSharepoints;
  });
};

// Add SharePoint to your filtered data function
const getFilteredSharePointData = () => {
  return (sharepoints || []).map(({ 
    id, url, order, sharepoint_name, connectionState, sharepoint_id, excludedItems, visibility,
    // ADD THESE MISSING URL TARGETING FIELDS:
    url_type, target_list_id, target_library_id, target_folder_path, 
    original_url, connection_method, url_analysis
  }) => ({
    id,
    url,
    order,
    sharepoint_name,
    connectionState,
    sharepoint_id,
    excludedItems,
    visibility,
    // ADD THESE URL TARGETING FIELDS TO THE RETURN OBJECT:
    url_type,
    target_list_id,
    target_library_id,
    target_folder_path,
    original_url,
    connection_method,
    url_analysis
  }));
};
    useEffect(() => {
      // console.log("tempInstructions")
      // console.log(tempInstructions)
    },[tempInstructions]);
    useEffect(() => {
      // alert(systemConfig.find(item => item.Id === 'prompt1')?.ConfigValue)
      const prompt1Value = systemConfig.find(item => item.Id === 'prompt1')?.ConfigValue || '';
      setPrompt1Text(prompt1Value);
      const prompt2Value = systemConfig.find(item => item.Id === 'prompt2')?.ConfigValue || '';
      setPrompt2Text(prompt2Value);
      const prompt3Value = systemConfig.find(item => item.Id === 'prompt3')?.ConfigValue || '';
      setPrompt3Text(prompt3Value);
      const prompt4Value = systemConfig.find(item => item.Id === 'prompt4')?.ConfigValue || '';
      setPrompt4Text(prompt4Value);
      let defaultInstruction = systemConfig.find(item => item.Id === 'instruction')?.ConfigValue || '';
      setInstructions(defaultInstruction);
      setTempInstructions(defaultInstruction);
      let defaultGreetingText = systemConfig.find(item => item.Id === 'greeting')?.ConfigValue || '';
      setGreetingSettings((prev) => ({ ...prev, 'text': defaultGreetingText }));

      let crawl_depth = systemConfig.find(item => item.Id === 'crawl_depth')?.ConfigValue ?? '2';
      setCrawlDepth(crawl_depth)
    }, [systemConfig]);
    
    
    const [inputText, setInputText] = useState(''); 
    const [messages, setMessages] = useState<string[]>([]);
    const messagesEndRef = useRef<HTMLDivElement | null>(null); 
    const [hasNewMessage, setHasNewMessage] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    const closeUsageMetrics = () => {
      setIsChatOpen(false); // This will close the modal
    };
    

    const handlePublicWebsites = () => setWebisteModalOpen(!isWebsiteModalOpen);
    const [isWebsiteModalOpen, setWebisteModalOpen] = useState(false);
    const [excludedWebsiteLinks, setExcludedWebsiteLinks] = useState<string[]>([]);
    const [websites, setWebsites] = useState<WebsiteData[]>(() => {
      return assistant?.id 
        ? [] // Empty array when editing an existing assistant
        : [{
            id: 1,
            website_id:'',
            url: '',
            order: 1,
            website_name: 'Website 1',
            activeTab: 'CONNECT',
            label: 'Website 1',
            connectionState: 'idle',
            status:'idle',
            document_id: '',
            UrlError:'',
            includeExternalLinks: false, // Add to manage the external links toggle
            restrictToStartPath: true,
            excludePatterns: [], // To store excluded patterns
            followLinkLevel: String(crawlDepth), // Dropdown for follow link levels
            websiteItems: {
              url: [],
              include_external_link: [],
              excluded_pattern: [],
              follow_link: [],
            },
            websites_links:[],
            isLoadingItems: false,
            error: undefined,
            excludedLinks:[],
          }];
    });
    
    const [isWebsiteRNightly, setIsWebsiteRNightly] = useState(false);
    useEffect(() => {
        const fetchAssistantData = async () => {
            if (assistant?.app_id ) {
              setIsFetching(true);
                const netId = localStorage.getItem("netId") || undefined;
                try {
                const data = await getAssistantById(assistant.app_id, netId);
                assistant.owner_name = data?.owner_name;
                assistant.app_publishstatus = data?.app_publishstatus; // Update publish status from API
                //set greetings
                const appAISettings = data?.app_ai_settings;
                assistant.app_ai_face = data?.app_ai_face;
                assistant.app_description = data?.app_description;
                setDescription(data?.app_description)
                if(appAISettings){
                    setGreetingSettings({
                    isChecked: appAISettings.ai_showgreeting === "true" || appAISettings.ai_showgreeting === true, // Default to true if "yes", otherwise false
                    text: appAISettings.ai_greeting
                  })
                  setStarterChecked(appAISettings.ai_showsuggestedprompts === "true" || appAISettings.ai_showsuggestedprompts === true);
                  setPrompt1Text(appAISettings.ai_suggestedprompt1)
                  setPrompt2Text(appAISettings.ai_suggestedprompt2)
                  setPrompt3Text(appAISettings.ai_suggestedprompt3)
                  setPrompt4Text(appAISettings.ai_suggestedprompt4)
                }
                //set app_chat_settings
                const appChatSettings = data?.app_chat_settings;
                if(appChatSettings){
                  setModal(appChatSettings.chat_model); 
                 
                  // Debugging previous value
                  const newTemp = Number(appChatSettings.chat_temperature); // Convert string to number
                  setTemperature(newTemp);

                  const newMaxLength = Number(appChatSettings.chat_maxlength); // Convert string to number
                  setMaximumLength(newMaxLength);

                  const newstopSeq = appChatSettings.chat_stopsequence; // Convert string to number
                  setStopSequences(newstopSeq);

                  const newTopP = Number(appChatSettings.chat_topP); // Convert string to number
                  setTopP(newTopP);
                 
                  const newFreqPen = Number(appChatSettings.chat_frequencypenalty); // Convert string to number
                  
                  setFPenalty(newFreqPen);

                  const newPreqPen = Number(appChatSettings.chat_presencepenalty); // Convert string to number
                  setPPenalty(newPreqPen);
                  
                  assistant.app_chat_settings = appChatSettings;
                  // assistant?.
                  // console.log("After setting temperature (immediate):", newTemp);
                  
                  
                }
                setInstructions(data?.app_prompt)
                // alert(data?.app_prompt)
                setTempInstructions(data?.app_prompt)
                // Set the UI settings based on app_ui_settings from the fetched data
                const appUISettings = data?.app_ui_settings;
                if (appUISettings) {
                  setBgColor(appUISettings.ui_backgroundcolor || bgColor); // Default to existing state if not provided
                  setFontColor(appUISettings.ui_fontcolor || fontColor); // Default to existing state if not provided
                  setIconColor(appUISettings.ui_iconcolor || iconColor); // Default to existing state if not provided
                  setHeaderColor(appUISettings.ui_headercolor || headerColor); // Default to existing state if not provided
                  setLogo(appUISettings.ui_logo || logo); // Default to existing state if not provided
                  setIsShowHeader(appUISettings.ui_showheader !== undefined ? appUISettings.ui_showheader : isShowHeader); // Default to existing state if not provided
                  
                }

                //set canvas courses
                const canvasDataOnEdit = data?.knowledge_data?.canvas_course ?? [];
                if (assistant?.id && Array.isArray(canvasDataOnEdit) && canvasDataOnEdit.length !== courses.length &&  canvasDataOnEdit.length !==0) {
                    setCourses(canvasDataOnEdit);
                }
               
                //set panopto courses            
                const panoptoDataOnEdit = data?.knowledge_data?.panopto ?? [];
                
                if (assistant?.id && Array.isArray(panoptoDataOnEdit) &&  panoptoDataOnEdit.length !==0) {
                  // alert('inside panopto')  
                  setPanoptos(panoptoDataOnEdit);
                }

                setSelectedFiles(data?.knowledge_data?.data_uploaded_files)
                if (assistant?.id){
                   assistant.data_uploaded_files = data?.knowledge_data?.data_uploaded_files;
                }

                const sharepointDataOnEdit = data?.knowledge_data?.sharepoint ?? [];
                if (assistant?.id && Array.isArray(sharepointDataOnEdit) && sharepointDataOnEdit.length !== 0) {
                  const updatedData = sharepointDataOnEdit.map((item) => ({
                    ...item,
                    activeTab: 'CONNECT',
                    // ENSURE VISIBILITY EXISTS
                    visibility: item.visibility || {
                      lists: true,
                      document_libraries: true,
                    },
                    // ENSURE EXCLUDED ITEMS EXISTS  
                    excludedItems: {
                      excluded_lists: item.excludedItems?.excluded_lists || [],
                      excluded_document_libraries: item.excludedItems?.excluded_document_libraries || [],
                      partial_excluded_document_libraries: item.excludedItems?.partial_excluded_document_libraries || [],
                    },
                    // ADD THESE URL TARGETING FIELDS WITH DEFAULTS:
                    url_type: item.url_type || 'site',
                    target_list_id: item.target_list_id || undefined,
                    target_library_id: item.target_library_id || undefined,
                    target_folder_path: item.target_folder_path || undefined,
                    original_url: item.original_url || undefined,
                    connection_method: item.connection_method || undefined,
                    // RECONSTRUCT URL ANALYSIS OBJECT:
                    url_analysis: item.url_analysis || {
                      url_type: item.url_type || 'site',
                      target_list_id: item.target_list_id,
                      target_library_id: item.target_library_id,
                      target_folder_path: item.target_folder_path
                    }
                  }));
                  setSharepoints(updatedData);
                }

                setCalenderSelectedFiles(data?.knowledge_data?.calendar_data)
                if (assistant?.id){
                   assistant.calendar_data = data?.knowledge_data?.calendar_data;
                }
                setIsWebsiteRNightly(data?.website_refresh_nightly !== undefined 
                  ? data?.website_refresh_nightly 
                  : false)
                setIsCanvasRNightly(data?.canvas_refresh_nightly !== undefined 
                  ? data?.canvas_refresh_nightly 
                  : false)
                setIsPanoptoRNightly(data?.panopto_refresh_nightly !== undefined 
                    ? data?.panopto_refresh_nightly 
                    : false)
                setIsCustomFileRNightly(data?.custom_file_refresh_nightly !== undefined 
                  ? data?.custom_file_refresh_nightly 
                  : false)

                setIsWebsiteFullLoad(data?.website_full_load !== undefined 
                    ? data?.website_full_load 
                    : false)
                setIsCanvasFullLoad(data?.canvas_full_load !== undefined 
                  ? data?.canvas_full_load 
                  : false)
                setIsPanoptoFullLoad(data?.panopto_full_load !== undefined 
                  ? data?.panopto_full_load 
                  : false)
                setIsCustomFileFullLoad(data?.customfile_full_load !== undefined 
                  ? data?.customfile_full_load 
                  : false)

                setIsSharePointRNightly(data?.sharepoint_refresh_nightly !== undefined 
                  ? data?.sharepoint_refresh_nightly 
                  : false)
                setIsSharePointFullLoad(data?.sharepoint_full_load !== undefined 
                  ? data?.sharepoint_full_load 
                  : false)

                setMetricsEmail(data?.is_metrics_email !== undefined
                  ? data?.is_metrics_email
                  : false)
                if (data?.metrics_email) {
                  setMetricsEmailAddress(data.metrics_email);
                } else {
                  setMetricsEmailAddress(getUserEmail());
                }

                // Load user file upload and text to speech settings (default to true if not present)
                setIsUserFileUploadEnabled(data?.user_file_upload_enabled !== undefined
                  ? data?.user_file_upload_enabled === 'true' || data?.user_file_upload_enabled === true
                  : true)
                setIsSpeechToTextEnabled(data?.speech_to_text_enabled !== undefined
                  ? data?.speech_to_text_enabled === 'true' || data?.speech_to_text_enabled === true
                  : true)

                const publicWebisteDataOnEdit = data?.knowledge_data?.public_websites ?? [];

                if (assistant?.id && Array.isArray(publicWebisteDataOnEdit)) {
                    const normalizedWebsites = publicWebisteDataOnEdit.map((site: any) => {
                        const includeExternal = site?.includeExternalLinks === true;
                        // Legacy rows saved before restrictToStartPath was persisted have no
                        // stored value; default them to true (the UI default) rather than off.
                        const restrictPath = site?.restrictToStartPath !== false;
                        if (includeExternal && restrictPath) {
                            // The two are mutually exclusive. Honor an explicitly-saved
                            // restrictToStartPath=true (force external off); otherwise keep
                            // the saved external-links choice and clear the defaulted restrict.
                            if (site?.restrictToStartPath === true) {
                                logger.warn(
                                    'Website source had both includeExternalLinks and restrictToStartPath set to true; forcing includeExternalLinks=false.',
                                    { website_id: site?.website_id, url: site?.url }
                                );
                                return { ...site, includeExternalLinks: false, restrictToStartPath: true };
                            }
                            return { ...site, restrictToStartPath: false };
                        }
                        return { ...site, restrictToStartPath: restrictPath };
                    });
                    setWebsites(normalizedWebsites);
                }

                setIncludeCommonKnowledge(data?.knowledge_data?.include_common_knowledge !== undefined
    ? data?.knowledge_data?.include_common_knowledge === 'true' || data?.knowledge_data?.include_common_knowledge === true
    : false
);


                // if (assistant?.id){
                //     assistant.include_common_knowledge = data?.knowledge_data?.include_common_knowledge;
                // }
               
                setAssistant((prev) => ({
                  ...prev,
                  messages_per_month_limit: data.messages_per_month_limit,
                }));
                setAssistant((prev) => ({
                  ...prev,
                  vector_top_k: data.vector_top_k,
                }));

                setAssistant((prev) => ({
                  ...prev,
                  chunk_size: data.chunk_size,
                }));
                setAssistant((prev) => ({
                  ...prev,
                  everyoneChecked: data.is_everyone,
                }));
                
                setAssistant((prev) => ({
                  ...prev,
                  is_authentication_enabled: data.is_authentication_enabled,
                }));
                // console.log("Is Authentication Enabled:");
                // console.log(data.is_authentication_enabled)
              setSettings((prev) => ({
                ...prev,
                isAuthenticationEnabled: data.is_authentication_enabled !== undefined 
                  ? data.is_authentication_enabled 
                  : true, // Preserve false, default to true only if missing
                canvasUserEnabled: data.canvas_user_enabled !== undefined 
                  ? data.canvas_user_enabled 
                  : true,
                localUserEnabled: data.local_user_enabled !== undefined 
                  ? data.local_user_enabled 
                  : true,
                socialLoginEnabled: data.social_login_enabled !== undefined 
                  ? data.social_login_enabled 
                  : false,
                everyOneEnabled: data.is_everyone !== undefined 
                  ? data.is_everyone 
                  : false,
                selectedSocialLogins: data.selected_social_logins ?? [],
                canvas_users_excluded: data.canvas_users_excluded 
                ? data.canvas_users_excluded : [],
                local_users_included: data.local_users_included ?? [],
              }));
              if (Array.isArray(data?.co_owner)) {
                setSelectedCoOwners(data.co_owner);
                const isCoOwner = data.co_owner.some(
                  (owner: { net_id: string; role: string }) =>
                    owner.net_id === netId && owner.role === "co-owner"
                );
                setIsCurrentUserCoOwner(isCoOwner);
                if(!isCoOwner){
                  const isAppOwner = data.app_owner === netId;
                  setIsCurrentUserCoOwner(isAppOwner);
                }
              }
              else{
                const isAppOwner = data.app_owner === netId;
                setIsCurrentUserCoOwner(isAppOwner);
              }
                // Update state with fetched data
                // Example: setAssistantData(data);
                
                // setWebsites(data?.data_public_websites?.websites?.map((site: any) => ({
                //     url: site.website_url,
                //     label: site.website_name
                // })) || []);

                // setCourses(
                //   data?.knowledge_data?.canvas_course?.map((course: any) => ({
                //     id: course.id,
                //     name: course.name,
                //     description: course.description,
                //     url:course.url,
                //     order: course.order,
                //     activeTab: 'BROWSE',
                //     connectionState: 'connected',
                //     course_id: course.course_id,
                //     excludedItems: course.excludedItems,
                //     visibility: course.visibility,
                //     // Add other course properties as needed
                //   })) || []
                // );
                setIsFetching(false);
                setHasFetched(true);
                setIsInitialLoadDone(true);

                // Set publish status after data is loaded from API
                if (assistant?.app_publishstatus) {
                    setAppPublishStatus(assistant.app_publishstatus?.toUpperCase());
                } else {
                    setAppPublishStatus("UNPUBLISHED");
                    assistant.app_publishstatus = 'UNPUBLISHED';
                }
                } catch (error: any) {
                  setIsFetching(false);
                  if (error.status === 403) {
                    setUrlLoadError('You do not have permission to access this Virtual Assistant.');
                  } else if (error.status === 404) {
                    setUrlLoadError('Virtual Assistant not found.');
                  } else {
                    console.error('Error fetching assistant data:', error);
                  }
                }
            }
        };

        fetchAssistantData();
    }, [assistant?.app_id]);
    // Scroll to the bottom when the messages array changes
    useEffect(() => {
        if (hasNewMessage && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            setHasNewMessage(false); // Reset the flag
        }
    }, [messages, hasNewMessage]);
    
    
    const sendChatClick = () => {
        if (inputText.trim() !== '') { // Ensure the input is not empty
            setMessages((prevMessages) => [...prevMessages, inputText]); // Append the new message
            setInputText(''); // Clear the input field
            setHasNewMessage(true);
        }
    };
    
    const [userName, setText] = useState<string>(
        assistant?.app_name || ``
    );
    const [description, setDescription] = useState<string>(
        assistant?.app_description || '' 
    );
    const [errors, setErrors] = useState<{ userName?: string; description?: string, greetingText?: string, prompt1?: string, prompt2?: string, prompt3?: string, prompt4?: string }>({});

    
    const [messages_per_month_limit, setMsgPerMonthLimit] = useState<number>(0);
    let KaiBlobLocation = systemConfig.find(item => item.Id === 'blob_root_folder')?.ConfigValue;
    const defaultAIFace = KaiBlobLocation + "/logo/boticondefault.svg";
    const [safeAiIconSrc, setSafeAiIconSrc] = useState<string>(assistant?.app_ai_face || defaultAIFace);
    // Update safe source when app_ai_face changes
    useEffect(() => {
      const updateSafeSource = async (): Promise<void> => {
        const src = assistant?.app_ai_face || defaultAIFace;
        const safeSrc = await getSafeImageSrc(src);
        setSafeAiIconSrc(safeSrc);
      };
    
    updateSafeSource();
  }, [assistant?.app_ai_face]);
  // Load system configuration from sessionStorage
    

    
    const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newName = event.target.value;  // Get the new name from the event
    setText(newName);
    
    // Auto-generate greeting for new VAs when name is entered - use newName, not userName
    if (!assistant?.app_id && newName.trim() && !greetingSettings.text.trim()) {
      const autoGreeting = `Hello! I'm ${newName}.\n\nHow may I help you?`;
      setGreetingSettings(prev => ({ ...prev, text: autoGreeting }));
    }
    
    if (newName.trim() === '') {
      setErrors((prev) => ({ ...prev, userName: 'Name is required' }));
    } else {
      setErrors((prev) => ({ ...prev, userName: undefined }));
    }
};
    
      const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDescription(event.target.value);
        if (event.target.value.trim() === '') {
          setErrors((prev) => ({ ...prev, description: 'Description is required' }));
        } else {
          setErrors((prev) => ({ ...prev, description: undefined }));
        }
      };

      const handleGreetingTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        handleGreetingSettingsChange("text", event.target.value);
        if(isInitialLoadDone)
          setHasChanges(true);
        if (event.target.value.trim() === '') {
          setErrors((prev) => ({ ...prev, greetingText: 'Greeting text is required' }));
        } else {
          setErrors((prev) => ({ ...prev, greetingText: undefined }));
        }
      };
    
      const handlePrompt1Change = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt1Text(event.target.value);
        if(isInitialLoadDone)
          setHasChanges(true);
        // if (event.target.value.trim() === '') {
        //   setErrors((prev) => ({ ...prev, prompt1: 'Prompt 1 is required' }));
        // } else {
        //   setErrors((prev) => ({ ...prev, prompt1: undefined }));
        // }
      };
    
       
      const handlePrompt2Change = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt2Text(event.target.value);
        if(isInitialLoadDone)
          setHasChanges(true);
        // if (event.target.value.trim() === '') {
        //   setErrors((prev) => ({ ...prev, prompt2: 'Prompt 2 is required' }));
        // } else {
        //   setErrors((prev) => ({ ...prev, prompt2: undefined }));
        // }
      };
    
      const handlePrompt3Change = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt3Text(event.target.value);
        if(isInitialLoadDone)
          setHasChanges(true);
        // if (event.target.value.trim() === '') {
        //   setErrors((prev) => ({ ...prev, prompt3: 'Prompt 3 is required' }));
        // } else {
        //   setErrors((prev) => ({ ...prev, prompt3: undefined }));
        // }
      };
    
      const handlePrompt4Change = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPrompt4Text(event.target.value);
        if(isInitialLoadDone)
          setHasChanges(true);
        // if (event.target.value.trim() === '') {
        //   setErrors((prev) => ({ ...prev, prompt4: 'Prompt 4 is required' }));
        // } else {
        //   setErrors((prev) => ({ ...prev, prompt4: undefined }));
        // }
      };

      
      const [leftWidth, setLeftWidth] = useState(1000); // Initial width of left section
      const [rightWidth, setRightWidth] = useState(450); // Initial width of right section
      
    

      const handleMouseDown = (event: React.MouseEvent) => {
       
        // alert('isResizing')
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    // Helper function to get the min width based on screen size
const getMinWidth = () => {
  if (window.innerWidth <= 768) {
      return 200; // Min width for mobile (adjust as needed)
  } else if (window.innerWidth <= 1024) {
      return 300; // Min width for tablet (adjust as needed)
  } else {
      return 400; // Min width for large desktops
  }
};

// Helper function to get the max width based on screen size
const getMaxWidth = () => {
  // alert(window.innerWidth)
  if (window.innerWidth <= 768) {
      return window.innerWidth - 50; // Max width for mobile (adjust as needed)
  } else if (window.innerWidth <= 1024) {
      return window.innerWidth - 100; // Max width for tablet (adjust as needed)
  } else {
      return window.innerWidth - 550; // Max width for large desktops
  }
};
    const handleMouseMove = (event: MouseEvent) => {    
        const newLeftWidth = event.clientX; // Mouse X position determines left section width
        // const minLeftWidth = 400; // Minimum width for left panel
        // const maxLeftWidth = window.innerWidth - 550; // Right panel should have a min width
        const minLeftWidth = getMinWidth();
        const maxLeftWidth = getMaxWidth();
        // console.log("newLeftwidth:"+newLeftWidth)
        // alert(maxLeftWidth)
    
        if (newLeftWidth > minLeftWidth && newLeftWidth < maxLeftWidth) {
            setLeftWidth(newLeftWidth);
            setRightWidth(window.innerWidth - newLeftWidth - 10); // Adjust right section
        }
    };
    
    const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    };

    const handleTouchStart = (event: React.TouchEvent) => {
      // Same logic as mouse down
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
  };
  
  const handleTouchMove = (event: TouchEvent) => {
    const touch = event.touches[0]; // Get the first touch
    const newLeftWidth = touch.clientX;

    // Dynamically calculate min and max widths based on screen size
    const minLeftWidth = getMinWidth();
    const maxLeftWidth = getMaxWidth();

    if (newLeftWidth > minLeftWidth && newLeftWidth < maxLeftWidth) {
        setLeftWidth(newLeftWidth);
        setRightWidth(window.innerWidth - newLeftWidth - 10); // Adjust right section width
    }
};

  const handleToggleEmailReports = () => {
    const newValue = !isMetricsEmail;
    setMetricsEmail(newValue);
    if(isInitialLoadDone)
        setHasChanges(true);
};
  const handleTouchEnd = () => {
      // Same logic as mouse up
      document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
  };
    
  
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const onDrop = (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        setSelectedFile(acceptedFiles[0]);
      }
    };
  const [selectedFiles, setSelectedFiles] = useState<UploadedFile[]>([]); // Define state type

  // Callback function with explicit type
  const handleUploadComplete = useCallback((files: UploadedFile[]) => {
    setSelectedFiles(files);
    // console.log("After passing:");
    // console.log(selectedFiles);
  },[]);

  const [selectedCalenderFiles, setCalenderSelectedFiles] = useState<CalenderFile[]>([]); // Define state type
  const handleCalenderUploadComplete = useCallback((files: CalenderFile[]) => {
    setCalenderSelectedFiles(files);
    // console.log("After passing:");
    // console.log(selectedCalenderFiles);
  },[]);

  useEffect(() => {
    // console.log("✅ Updated selectedFiles in Parent:", selectedCalenderFiles);
  }, [selectedCalenderFiles]); 

  useEffect(() => {
    // console.log("✅ Updated selectedFiles in Parent:", selectedFiles);
  }, [selectedFiles]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false, // If you want to accept multiple files, set this to true
    accept: {
      "image/*": [], // Accept all image types
      "application/pdf": [], // Accept PDF files
    },
  });

   const handleEditChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!file.type.startsWith('image/')) {
        console.error('Only image files are allowed.');
        return;
      }

      try {
        const fileLocation = await uploadFile(file, 'aiface', assistant?.app_id || '' , localStorage.getItem('netId') || '');
        // alert(JSON.stringify(fileLocation))
        const location= fileLocation.fileLocation;
        setAssistant((prev) => ({
            ...prev,
            app_ai_face: location
        }));
        setHasChanges(true);
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  };

     //for downarrow click
     const [isActionModalOPen, setIsActionModalOpen] = useState(false);

     const handleOverlayClick = () => {
        setIsActionModalOpen(false);
      };

     const toggleModal = () => {
        setIsActionModalOpen(prevState => !prevState);
     };

    const [isChatOpen, setIsChatOpen] = useState(false);

    const handleDeleteVA = async () => {
        setIsActionModalOpen(false);
        let warningMessage = 'This action will permanently remove all related data and cannot be undone. Are you sure you want to delete the Chatbot?';
        if (assistant?.app_publishstatus.toUpperCase() === 'PUBLISHED') {
            warningMessage = 'This Chatbot is currently published. This action will permanently remove all related data and cannot be undone. Deleting it will make it unavailable for end users. Are you sure you want to proceed?';
        }

        showDeleteConfirmationModal(warningMessage, async () => {
            // console.log("Confirm button clicked");
      
            // Close confirmation modal
            setCustomModal((prev) => ({
              ...prev,
              isOpen: false,
            }));
      
            // Show loading modal
            setCustomModal({
              isOpen: true,
              title: "Deleting...",
              message: warningMessage,
              type: "loading", // Display loader
            });

            try {
       
                const [ responseData ] = await Promise.all([
                    deleteVirtualAssistant(assistant?.app_id).catch(() => ({ data: [] })),
                ]);
                
                if (responseData && responseData?.message) {
                    setCustomModal({
                        isOpen: true,
                        title: "Success!",
                        message: responseData?.message,
                        type: "success",
                    });
                    navigate('/');
                    
                }  else {
                    // Handle failure case if needed
                    setCustomModal({
                        isOpen: true,
                        title: "Error!",
                        message: "There was an issue deleting the chatbot.",
                        type: "error",
                      });
                }
            }
            catch (error) {
                console.log("API call failed", error);
                setCustomModal({
                  isOpen: true,
                  title: "Error!",
                  message: "There was an error with the request.",
                  type: "error",
                });
              }
        })
    };


    const handleClone = async () => {
      setIsActionModalOpen(false);
      showCloneConfirmationModal(`Do you want to create a copy of ${assistant?.app_name}?`, async () => {
        setCustomModal((prev) => ({ ...prev, isOpen: false }));

        setCustomModal({
          isOpen: true,
          title: "Cloning...",
          message: "Please wait while the chatbot is being cloned.",
          type: "loading",
        });
        try {
                const clonedAssistant = await cloneVirtualAssistant(assistant?.id);
                // assistant?.app_id = assistant
                setCustomModal({
                  isOpen: true,
                  title: "Success!",
                  message: "Chatbot cloned successfully.",
                  type: "success",
                });
                navigate('/buildNewAssistant', { 
                  state: { assistant: clonedAssistant },
                  replace: true, // Optional, use if you want to replace the current history entry
                });
                window.location.reload();
                //after cloning it should set assiatnt id as that
               
              } catch (error) {
                console.error('Error cloning chatbot:', error);
                setCustomModal({
                  isOpen: true,
                  title: "Fail!",
                  message: "Failed to clone chatbot.",
                  type: "error",
                });
              }
  
      });
      };
     
      const handleCopyAppUrl = async () => {
        setIsActionModalOpen(false);
        const storedInferenceURL = localStorage.getItem("inference_url");
        var coping_inference_url = storedInferenceURL + assistant?.id;
        await navigator.clipboard.writeText(coping_inference_url);
        setCustomModal({
          isOpen: true,
          title: "Success!",
          message: coping_inference_url,
          type: "success",
        });
      };
      const handleExport = async () => {
        setIsActionModalOpen(false);
        showExportConfirmationModal("Do you want to export this chatbot?", async () => {
              setCustomModal((prev) => ({
                ...prev,
                isOpen: false,
              }));
        
              // Show loading modal
              setCustomModal({
                isOpen: true,
                title: "Exporting...",
                message: "Please wait while the chatbot is being exported.",
                type: "loading", // Display loader
              });
        
              try {
                const response = await exportVirtualAssistant(assistant.app_id);
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${assistant.app_name}.json`);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                setCustomModal({
                  isOpen: true,
                  title: "Success!",
                  message: "Chatbot exported successfully.",
                  type: "success",
                });
              } catch (error) {
                console.error('Error exporting chatbot:', error);
                setCustomModal({
                  isOpen: true,
                  title: "Error!",
                  message: "There was an issue exporting the chatbot.",
                  type: "error",
                });
              }
            });
        };
    const handleConfirmShowModal = async (action: 'publish' | 'unpublish') => {
        const message = action === 'publish' ? 'Are you sure you want to publish the chatbot?'
        : 'Are you sure you want to unpublish the chatbot?';
         // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        });
  
        // If the user confirms the action
        if (result.isConfirmed) {
            // Handle the action (publish or unpublish)
            if (action === 'publish') {
                handlePublishAssistant();
                
            } else {
                handleunpublishAssistant();
            }
        }
    };    
     const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    
     

     useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
          if (isActionModalOPen && !document.getElementById('actionModal')?.contains(event.target as Node)) {
            setIsActionModalOpen(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [isActionModalOPen]);

      const [courseIds, setCourseIds] = useState<CourseIdentifier[]>([]);

      const getCourseIdentifiers = (): CourseIdentifier[] => {
        return courses
          .filter(course => course.connectionState === 'connected' && course.course_id)
          .map(course => ({
            course_id: course.course_id,
            course_url: course.url ?? undefined,  // assuming `course_url` is available on each course
          }));
      };
      
      // useEffect to update courseIds when connectionState becomes 'connected'
      useEffect(() => {
        const newIds = getCourseIdentifiers();

          const isDifferent = JSON.stringify(courseIds) !== JSON.stringify(newIds);

          if (newIds.length > 0) {
            setCourseIds(prevIds => (isDifferent ? newIds : prevIds));
          } else {
            setCourseIds(prev => (prev.length > 0 ? [] : prev));
          }
      }, [courses, courseIds]);

      


const getFilteredPanoptoData = () => {
  return panoptos.map(({ id, order, connectionState, excludedItems, panopto_id, panopto_name }) => ({
    id,
    order,
    connectionState,
    excludedItems,
    panopto_id,
    panopto_name,
  }));
};

const getFilteredCanvasData = () => {
  return courses.map(({ id, course_id, url,tenant,order,connectionState, course_name, excludedItems,visibility }) => ({
    id,
    course_id,
    url,
    tenant,
    order,
    connectionState,
    course_name,
    excludedItems,
    visibility
  }));
};


const getFilteredFileData = () => {
  return (selectedFiles || []).map(({ id, file, file_name, file_type, sequence, file_url,file_extn,size, file_unique_id }) => ({
    id,
    file,
    file_name,
    file_type,
    sequence,
    file_url,
    file_extn,
    size,
    file_unique_id
  }));
};
const getFilteredCalenderData = () => {
  return (selectedCalenderFiles || []).map(({ id, file, file_name, file_type, sequence, file_url,file_extn,size }) => ({
    id,
    file,
    file_name,
    file_type,
    sequence,
    file_url,
    file_extn,
    size,
  }));
};

const getFilteredWebsiteData = () => {
  return (websites || []).map(({ id, url, order, website_name, includeExternalLinks, restrictToStartPath, excludePatterns,followLinkLevel,connectionState,website_id, document_id,excludedLinks }) => ({
    id,
    url,
    order,
    website_name,
    includeExternalLinks,
    restrictToStartPath: restrictToStartPath ?? false,
    excludePatterns,
    followLinkLevel,
    connectionState,
    website_id,
    document_id,
    excludedLinks
  }));
};



// const getColumns = () => {
//   // alert(leftWidth)
//   const rightWidth = containerWidth - leftWidth;
//   if (rightWidth < 250) {
//     return 1; // 1 column for small widths (4 rows)
//   } else if (rightWidth < 600) {
//     return 2; // 2 columns for medium widths (2 rows)
//   } else {
//     return 4; // 4 columns for large widths (1 row)
//   }
// };

   

    // console.log("local_users_included before auto-save:", settings.local_users_included)
    const [settings, setSettings] = useState({
        isAuthenticationEnabled: assistant?.is_authentication_enabled ?? true,
        canvasUserEnabled: assistant?.canvas_user_enabled ?? true,
        localUserEnabled: assistant?.local_user_enabled ?? true,
        socialLoginEnabled: assistant?.social_login_enabled ?? false,
        selectedSocialLogins: assistant?.selected_social_logins ?? [], 
        canvas_users_excluded: assistant?.canvas_users_excluded ?? [],
        local_users_included: assistant?.local_users_included ?? [],
        everyOneEnabled: assistant?.everyoneChecked ?? false,

      });

     

      // const handleSettingsChange = (updatedSettings: {
      //   canvasUsers?: CanvasUser[];
      //   canvasUserEnabled?: boolean;
      //   // other properties
      // }) => {
      //   console.log("Unchecked Canvas Users:", updatedSettings.canvasUsers);

      //   // Handle unchecked canvas users here
      //   // You can pass them to BuildNewAssistant or perform other actions as needed
      // };
      const handleSettingsChange = (updatedSettings: any) => {
        setSettings((prevSettings) => ({
          ...prevSettings,
          ...updatedSettings,
        }));
        if(isInitialLoadDone)
          setHasChanges(true); // Set hasChanges to true
      };

      const handlePanoptoTrigger = () => {
        if(isInitialLoadDone)
          setHasChanges(true);
        // setHasChanges(false); // Set hasChanges to true
        // // autoSave();
      };


const [isAutoSaving, setIsAutoSaving] = useState(false);
const [hasChanges, setHasChanges] = useState(false);
const changesDuringSaveRef = useRef(false); // Track if changes occurred while auto-save is in progress
const [isPublishOperationInProgress, setIsPublishOperationInProgress] = useState(false);

const autoSave = useCallback(async () => {
  if (isAutoSaving || !hasChanges || !isInitialLoadDone || isPublishOperationInProgress) {
    return; // Prevent autosave during publish/unpublish operations
  }
  if ( userName === '') {
    setErrors((prev) => ({ ...prev, userName: 'Name is required' }));
    return;

  } else {
    setErrors((prev) => ({ ...prev, userName: undefined }));
  }
   setIsAutoSaving(true);
   changesDuringSaveRef.current = false; // Reset the flag at the start of save
    const filteredPanopto = getFilteredPanoptoData();
    const FilteredCanvasData = getFilteredCanvasData();
    const FilteredFileData = getFilteredFileData();
    const FilteredCalenderFileData = getFilteredCalenderData();
    const connectedPanopto = panoptos?.filter(p => p.connectionState === "connected") || [];

    const connectedWebsites = getFilteredWebsiteData().filter(p => p.connectionState === "connected") || [];

    const connectedCanvas = getFilteredCanvasData().filter(p => p.connectionState === "connected") || [];

    const connectedSharePoint = getFilteredSharePointData().filter(p => p.connectionState === "connected") || [];

   
    let msg_per_month = systemConfig.find(item => item.Id === 'messages_per_month_limit')?.ConfigValue;
    if(assistant?.messages_per_month_limit){
      msg_per_month = assistant?.messages_per_month_limit
    }

    let vectorTopK = systemConfig.find(item => item.Id === 'vector_top_k')?.ConfigValue;
    if(assistant?.vector_top_k){
      vectorTopK = assistant?.vector_top_k
    }

    let chunkSize = systemConfig.find(item => item.Id === 'max_chunk_size')?.ConfigValue;
    if(assistant?.chunk_size){
      chunkSize = assistant?.chunk_size
    }
    //default ai face saving
    // if(!assistant?.app_ai_face){
    //     const response = await fetch('/bot_icon.svg');
    //     const blob = await response.blob();

    //     const file = new File([blob], 'bot_icon.svg', { type: 'image/svg+xml' });

    //     const fileLocation = await uploadFile(file, 'aiface');
    //     const location = fileLocation.fileLocation;
    //     setAssistant((prev) => ({
    //       ...prev,
    //       app_ai_face: location,
    //     }));
    // }
    // console.log(settings.local_users_included)
    const assistantData = {
        app_id: assistant?.app_id ? assistant?.app_id : '',
        app_ai_face: assistant?.app_ai_face ? assistant?.app_ai_face : defaultAIFace,
        app_owner: assistant?.app_owner ? assistant?.app_owner : localStorage.getItem('netId'),
        owner_name:assistant?.owner_name ? assistant?.owner_name : localStorage.getItem('fullName'),
        app_embedcode: assistant?.app_embedcode ? assistant?.app_embedcode : '',
        last_modified: assistant?.last_modified ? assistant?.last_modified : '',
        app_url: assistant?.app_url ? assistant?.app_url : '',
        id: assistant?.app_id ? assistant?.app_id : '',
        app_name: userName,
        app_description: description ,
        app_publishstatus: appPublishStatus,
        app_prompt: instructions,
        app_ui_settings: {
            ui_backgroundcolor: bgColor,
            ui_fontcolor: fontColor,
            ui_iconcolor: iconColor,
            ui_headercolor: headerColor,
            ui_logo: logo,
            ui_showheader: String(isShowHeader),  // Convert to string "true"/"false"
        },
        app_ai_settings: {
          ai_face:  assistant?.app_ai_face ? assistant?.app_ai_face : defaultAIFace,
          ai_name: userName,  // Required - adding this
          ai_showgreeting: String(greetingSettings.isChecked),  // Convert to string
          ai_greeting: greetingSettings.text,
          ai_showsuggestedprompts: String(isStartersChecked),  // Convert to string
          ai_suggestedprompt1: prompt1,
          ai_suggestedprompt2: prompt2,
          ai_suggestedprompt3: prompt3,
          ai_suggestedprompt4: prompt4,
      },
        app_chat_settings: {
          chat_model: modal,
          chat_temperature: String(temperature),  // Convert to string
          chat_maxlength: String(maximumLength),  // Convert to string
          chat_stopsequence: stopSequences,
          chat_topP: String(topP),  // Convert to string
          chat_frequencypenalty: String(fPenalty),  // Convert to string
          chat_presencepenalty: String(pPenalty),  // Convert to string
          chat_prompt: "",  // Required - add your default prompt
          chat_promptinjection: "",  // Required - add your default injection prompt
          chat_userag: navigator.userAgent  // Required - adding user agent
      },
        is_authentication_enabled: String(settings.isAuthenticationEnabled),
        canvas_user_enabled: String(settings.canvasUserEnabled),
        local_user_enabled: String(settings.localUserEnabled),
        social_login_enabled: String(settings.socialLoginEnabled),
        selected_social_logins: settings.selectedSocialLogins,
        canvas_users_excluded: settings.canvas_users_excluded, 
        local_users_included: settings.local_users_included, 
        
        knowledge_data: {
            public_websites: connectedWebsites,
            canvas_course: connectedCanvas,
            panopto: connectedPanopto,
             sharepoint: connectedSharePoint, // Add this line
            data_uploaded_files: FilteredFileData,
            calendar_data: FilteredCalenderFileData,
            include_common_knowledge: String(includeCommonKnowledge),
        },
        website_refresh_nightly: String(isWebsiteRNightly),
        canvas_refresh_nightly: String(isCanvasRNightly),
        panopto_refresh_nightly: String(isPanoptoRNightly),
        custom_file_refresh_nightly: String(isCustomFileRNightly),
        sharepoint_refresh_nightly: String(isSharePointRNightly),


        website_full_load: String(isWebsiteFullLoad),
        canvas_full_load: String(isCanvasFullLoad),
        panopto_full_load: String(isPanoptoFullLoad),
        customfile_full_load: String(isCustomFileFullLoad),
        sharepoint_full_load: String(isSharePointFullLoad),  
        messages_per_month_limit: msg_per_month,  
        vector_top_k: vectorTopK,  
        chunk_size: chunkSize,
        is_everyone: String(settings.everyOneEnabled),
        co_owner: selectedCoOwners,
        is_metrics_email: String(isMetricsEmail),
        metrics_email: String(metricsEmailAddress),
        user_file_upload_enabled: String(isUserFileUploadEnabled),
        speech_to_text_enabled: String(isSpeechToTextEnabled),
         // Required - add your excluded users list
    };
    // console.log("Assiatnt Data:****")

    // console.log(assistantData)
    try {
      let responseData: any;
        if (assistant?.id) {
            responseData = await updateAssistant(assistant?.app_id, assistantData);
        } else {
            responseData = await saveAssistant(assistant?.app_id, assistantData);
            // alert(responseData?.app_id)
            if (responseData?.app_id) {
              setAssistant((prev) => ({
                ...prev,
                app_id: responseData.app_id,
                id: responseData.app_id
            }));
              // Update URL so browser refresh loads this assistant
              window.history.replaceState(null, '', `/va/${responseData.app_id}`);
            }//
        }
        setIsAutoSaving(false);
        // Only reset hasChanges if no new changes occurred during the save
        if (!changesDuringSaveRef.current) {
            setHasChanges(false);
        }
    } catch (error) {
        console.error("Auto-save failed", error);
        setIsAutoSaving(false);
    }
}, [assistant?.app_id, assistant?.app_embedcode, assistant?.app_owner, assistant?.owner_name,
  assistant?.app_url, assistant?.id, assistant?.last_modified, appPublishStatus,
  bgColor, canvasCourses, courses, description, fontColor, greetingSettings.isChecked,
  greetingSettings.text, headerColor, isShowHeader, isStartersChecked, logo, modal, prompt1, prompt2, prompt3, prompt4, selectedFiles,
  settings.canvasUserEnabled, settings.isAuthenticationEnabled, settings.localUserEnabled,
  settings.selectedSocialLogins, settings.socialLoginEnabled,
   settings.local_users_included,stopSequences, temperature, topP, userName, websites, isAutoSaving, hasChanges, selectedCalenderFiles,isWebsiteRNightly,isCanvasRNightly, isPanoptoRNightly, isCustomFileRNightly, assistant?.calendar_data, assistant?.is_everyone,settings.everyOneEnabled,includeCommonKnowledge,selectedCoOwners,isMetricsEmail,metricsEmailAddress,isPublishOperationInProgress,maximumLength,fPenalty,pPenalty,isUserFileUploadEnabled,isSpeechToTextEnabled]);

   useEffect(() => {
   },[selectedCoOwners]);
useEffect(() => {
    const handle = setTimeout(autoSave, 2000); // Auto-save every 5 seconds
    return () => clearTimeout(handle);
}, [autoSave]);

// Function to handle changes and set the hasChanges flag
const handleChange = (
  nameOrSetter: string | React.Dispatch<React.SetStateAction<any>>,
  maybeSetterOrValue?: React.Dispatch<React.SetStateAction<any>> | any,
  maybeValue?: any
) => {
  let name: string | undefined;
  let setter: React.Dispatch<React.SetStateAction<any>>;
  let value: any;

  if (typeof nameOrSetter === "function") {
    // Call as: handleChange(setter, value)
    setter = nameOrSetter;
    value = maybeSetterOrValue;
  } else {
    // Call as: handleChange(name, setter, value)
    name = nameOrSetter;
    setter = maybeSetterOrValue as React.Dispatch<React.SetStateAction<any>>;
    value = maybeValue;
  }
  setter(value);
  if(isInitialLoadDone && name !== 'maxLength') {
    setHasChanges(true);
    // Track if changes happen while a save is in progress
    if (isAutoSaving) {
      changesDuringSaveRef.current = true;
    }
  }
};
const checkWebsiteCOnnectionState = () =>{
  const allConnected = websites.every((website) => website.connectionState === "connected");

  if (allConnected) {
    setHasChanges(true);
    // console.log("All websites are connected.");
  }
}
const handleCanvasChange = (setter: React.Dispatch<React.SetStateAction<any>>, value: any) => {
  // Update state with the new value
  setter(value);
  // checkWebsiteCOnnectionState();
};
const handlePanoptoChange = (setter: React.Dispatch<React.SetStateAction<any>>, value: any) => {
  // Update state with the new value
  setter(value);
  // checkWebsiteCOnnectionState();
};
const handleWebsiteChange = (setter: React.Dispatch<React.SetStateAction<any>>, value: any) => {
  // Update state with the new value
  setter(value);
  // checkWebsiteCOnnectionState();
};
const triggerWebsiteSave = () =>{
  if(isInitialLoadDone)
    setHasChanges(true)
}
const triggerCanvasSave = () =>{
  if(isInitialLoadDone)
    setHasChanges(true)
}
const triggerFileUploader = () => {
  if(isInitialLoadDone)
    setHasChanges(true)
}
const [copiedField, setCopiedField] = useState(null);

  const handleCopyClipBoard = (text:any, field:any) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);

    // Reset back to copy icon after 2 seconds
    setTimeout(() => setCopiedField(null), 2000);
  };

  const handleCoOwner = async (assistant: any) => {
      setIsCoOwnerModalOpen(true);
      setSelectedAppId(assistant?.app_id)
      const coOwners = Array.isArray(assistant?.co_owner) ? assistant.co_owner : [];
      //setSelectedCoOwners(coOwners as User[]);
      
    };

    const handleSaveCoOwners = async (selectedUsers: any, assistantId: any) => {
       setSelectedCoOwners(selectedUsers); 
        setHasChanges(true)
        setIsInitialLoadDone(true)
    };
    

   // Show loading state when loading from URL
   if (isLoadingFromUrl) {
     return (
       <div className="container mx-auto px-4 mt-20 overflow-hidden">
         <div className="flex flex-col items-center justify-center h-64">
           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
           <p className="text-gray-600">Loading Virtual Assistant...</p>
         </div>
       </div>
     );
   }

   // Show error state when there's a URL load error
   if (urlLoadError) {
     return (
       <div className="container mx-auto px-4 mt-20 overflow-hidden">
         <div className="flex flex-col items-center justify-center h-64">
           <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500 text-5xl mb-4" />
           <h2 className="text-xl font-semibold text-gray-800 mb-2">Access Denied</h2>
           <p className="text-gray-600 mb-4">{urlLoadError}</p>
           <button
             onClick={() => navigate('/')}
             className="flex items-center gap-2 px-4 py-2 bg-black text-white font-semibold rounded-lg hover:bg-gray-800"
           >
             <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
             Back to Home
           </button>
         </div>
       </div>
     );
   }

   return (
    <div className="container mx-auto px-4 mt-20  overflow-hidden">
        {/* Model Retirement Banner */}
        {showRetirementBanner && currentModelRetirement && (
            <ModelRetirementBanner
                retirementConfig={currentModelRetirement}
                onUpgrade={handleModelUpgrade}
                onDismiss={handleDismissRetirementBanner}
                isUpgrading={isUpgradingModel}
            />
        )}

        <div className="flex items-center mb-4 ">
            {/* Back Button */}
            <button onClick={handleBackClick} className="flex items-center text-black">
                <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
            </button>
           
            <input type="text" value={userName} onChange={(e) => handleChange(setText, e.target.value)} className="ml-2 pt-1 font-semibold border rounded px-1 w-[27%]"/>
            {errors.userName && <p className="text-red-500 text-sm">{errors.userName}</p>}
            
            <div className="ml-auto flex items-center gap-4">
                  <div className="flex items-center gap-2 px-4 py-2 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 focus:outline-none">
                    <span className="font-semibold">EMAIL DAILY USAGE SUMMARY</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={isMetricsEmail}
                            onChange={handleToggleEmailReports}
                        />
                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full
                                        peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5
                                        after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full
                                        after:h-5 after:w-5 after:transition-all peer-checked:bg-black"></div>
                    </label>
                </div>
                <button onClick={() => setIsChatHistoryModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
                     <FontAwesomeIcon icon={faMessage} className="h-5 w-5" />
                    CHAT HISTORY
                </button>
                <button onClick={() => setIsUsageMetricsModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
                    <FontAwesomeIcon icon={faChartColumn} className="h-5 w-5" />
                    USAGE METRICS
                </button>
                {hasFetched && (
                  <button onClick={appPublishStatus === "PUBLISHED" ? handleunpublishAssistant : handlePublishAssistant}
                  className="flex items-center gap-2 px-4 py-2 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
                      <FontAwesomeIcon icon={appPublishStatus === "PUBLISHED" ? faCircleCheck : faEyeSlash} className="h-5 w-5" />
                      {appPublishStatus === "PUBLISHED" ? "UNPUBLISH" : "PUBLISH"}
                  </button>
                )}
                {/* Down Arrow Button */}
                { assistant?.app_id && (
                <button onClick={toggleModal} className="p-2 bg-white text-black rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
                    <FontAwesomeIcon icon={faCaretDown} className="h-5 w-5" />
                </button>
                )}
                {isAutoSaving && (
                    <div className="flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-800 font-semibold rounded-lg">
                        <FontAwesomeIcon icon={faSave} className="h-5 w-5 animate-spin" />
                        Auto-saving...
                    </div>
                )}
            </div>
        </div>
        {/* Page Content */}
        {/* Horizontal Flex Container */}
        <div className="flex w-full relative">
            {/* First container with 70% width */}
            
            <div style={{width: `${leftWidth}px`, height: `${window.innerWidth > 1024 ? window.innerHeight + 100 : window.innerHeight}px`,}} className="h-full p-4 bg-gray-50 border rounded-lg shadow-lg overflow-y-auto " >
                
                {/* Section 1: Assistant Profile */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 mb-6">
                    <h2 className="text-2xl font-bold mb-6 pb-3 border-b border-gray-200">Assistant Profile</h2>
                    
                    <div className="flex items-center">
                        <div className="flex-1"></div>
                        <div className="flex flex-col items-center text-center"> 
                               {assistant?.app_ai_face ? (
                          <>
                            <img
                              src={safeAiIconSrc}  // Use the safe source here
                              alt="AI Face"
                              className="h-10 cursor-pointer"
                              onClick={() => document.getElementById("aiface")?.click()}
                            />
                            {assistant?.app_ai_face !== defaultAIFace && (
                                <button
                                  onClick={() => {
                                    setAssistant((prev) => ({ ...prev, app_ai_face: defaultAIFace }));
                                    setHasChanges(true);
                                  }}
                                  className="mt-2 text-sm text-red-600"
                                >
                                  Remove
                                </button>
                              )}
                          </>
                        ) : (
                          <button
                            onClick={() => document.getElementById("aiface")?.click()}
                            className="right-4 p-2 bg-white text-grey border border-gray-500 hover:bg-gray-100 focus:outline-none">
                            <img
                              src={defaultAIFace}  // Default image should be safe already
                              alt="AI Face"
                              className="h-10 cursor-pointer"
                            />
                          </button>
                        )}
                            <input
                                type="file"
                                id="aiface"
                                accept="image/*"
                                onChange={handleEditChange}
                                className="hidden"
                            />
                            <p className="mt-2 text-sm text-gray-600">Edit</p>
                        </div>
                        <div className="flex-1 flex justify-end">
                            <button onClick={advancedUIModal} 
                                className="p-2 ml-5 bg-white text-black border border-gray-500 font-semibold rounded-full hover:bg-black hover:text-white focus:outline-none">
                                Advanced UI Settings
                            </button>
                        </div>
                    </div>
                    
                    <div className="mt-6 ml-2">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                        <textarea id="name" name="name" className={`newassistant-input ${errors.userName ? 'border-red-500' : ''}`} value={userName} onChange={(e) => handleChange(setText, e.target.value)}></textarea>
                        {errors.userName && <p className="text-red-500 text-sm">{errors.userName}</p>}
                    </div>

                    <div className="mt-6 ml-2">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700"> Description</label>
                        <textarea id="description" name="description" className={`newassistant-input ${errors.description ? 'border-red-500' : ''}`} value={description} onChange={(e) => handleChange(setDescription, e.target.value)}></textarea>
                        {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
                    </div>
                </div>

                {/* Section 2: Conversation Settings */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 mb-6">
                    <h2 className="text-2xl font-bold mb-6 pb-3 border-b border-gray-200">Conversation Settings</h2>
                    
                    {/* Checkbox with Label */}
                    <div className="mt-6 ml-2 flex items-center">
                        <div className={`h-6 w-6 border-2 border-gray-300 rounded-full flex items-center justify-center cursor-pointer ${
                        greetingSettings.isChecked ? "bg-black" : "bg-white"}`} onClick={handleShowGreeting}>
                            {greetingSettings.isChecked && (
                                <FontAwesomeIcon icon={faCheck} className="h-4 w-4 text-white" />
                            )}
                        </div>
                        <label htmlFor="showGreeting" className="ml-2 text-sm text-gray-700">Show Greeting</label>
                    </div>
                    {greetingSettings.isChecked && (
                    <div className="mt-6 ml-2">
                        <textarea 
                        rows={3}
                        id="greeting_text" name="greeting_text" className={`newassistant-input ${errors.greetingText ? 'border-red-500' : ''}`} value={greetingSettings.text} 
                        onChange={handleGreetingTextChange}
                        ></textarea>
                        {errors.greetingText && <p className="text-red-500 text-sm">{errors.greetingText}</p>}
                    </div>
                    )}

                    <div className="mt-6 ml-2 flex items-center">
                        <div className={`h-6 w-6 border-2 border-gray-300 rounded-full flex items-center justify-center cursor-pointer ${isStartersChecked ? 'bg-black' : 'bg-white'}`}
                        onClick={handleShowStarter}>
                            {isStartersChecked && <FontAwesomeIcon icon={faCheck} className="h-4 w-4 text-white" />}
                        </div>
                        <label htmlFor="showGreeting" className="ml-2 text-sm text-gray-700">Show Conversation Starters</label>
                    </div>
                    {isStartersChecked && (
                    <>
                    <div className="mt-6 ml-2">
                        <label className="form-label">Suggested Prompt 1</label>
                        <textarea id="prompt1" name="prompt1" className={`newassistant-input ${errors.prompt1 ? 'border-red-500' : ''}`} value={prompt1} onChange={handlePrompt1Change}></textarea>
                        {errors.prompt1 && <p className="text-red-500 text-sm">{errors.prompt1}</p>}
                    </div>
                    <div className="mt-6 ml-2">
                        <label className="form-label">Suggested Prompt 2</label>
                        <textarea id="prompt2" name="prompt2" className={`newassistant-input ${errors.prompt2 ? 'border-red-500' : ''}`} value={prompt2} onChange={handlePrompt2Change}></textarea>
                        {errors.prompt2 && <p className="text-red-500 text-sm">{errors.prompt2}</p>}
                    </div>
                    <div className="mt-6 ml-2">
                        <label className="form-label">Suggested Prompt 3</label>
                        <textarea id="prompt3" name="prompt3" className={`newassistant-input ${errors.prompt3 ? 'border-red-500' : ''}`} value={prompt3} onChange={handlePrompt3Change}></textarea>
                        {errors.prompt3 && <p className="text-red-500 text-sm">{errors.prompt3}</p>}
                    </div>
                    <div className="mt-6 ml-2">
                        <label className="form-label">Suggested Prompt 4</label>
                        <textarea id="prompt4" name="prompt4" className={`newassistant-input ${errors.prompt4 ? 'border-red-500' : ''}`} value={prompt4} onChange={handlePrompt4Change}></textarea>
                        {errors.prompt4 && <p className="text-red-500 text-sm">{errors.prompt4}</p>}
                    </div>
                    </>
                    )}

                    {/* Allow users to upload files Toggle */}
                    <div className="mt-6 ml-2 flex items-center">
                        <div className={`h-6 w-6 border-2 border-gray-300 rounded-full flex items-center justify-center cursor-pointer ${
                        isUserFileUploadEnabled ? "bg-black" : "bg-white"}`}
                        onClick={() => {
                            setIsUserFileUploadEnabled(!isUserFileUploadEnabled);
                            if (isInitialLoadDone) setHasChanges(true);
                        }}>
                            {isUserFileUploadEnabled && (
                                <FontAwesomeIcon icon={faCheck} className="h-4 w-4 text-white" />
                            )}
                        </div>
                        <label className="ml-2 text-sm text-gray-700">Allow users to upload files</label>
                        <div className="inline-flex items-center ml-1.5 cursor-help" title="When enabled, users can attach and upload files directly in the chat conversation. When disabled, the file upload option will be hidden from the chat interface.">
                            <FontAwesomeIcon icon={faCircleInfo} className="h-3.5 w-3.5 text-gray-400" />
                        </div>
                    </div>

                    {/* Allow users to use voice input Toggle */}
                    <div className="mt-6 ml-2 flex items-center">
                        <div className={`h-6 w-6 border-2 border-gray-300 rounded-full flex items-center justify-center cursor-pointer ${
                        isSpeechToTextEnabled ? "bg-black" : "bg-white"}`}
                        onClick={() => {
                            setIsSpeechToTextEnabled(!isSpeechToTextEnabled);
                            if (isInitialLoadDone) setHasChanges(true);
                        }}>
                            {isSpeechToTextEnabled && (
                                <FontAwesomeIcon icon={faCheck} className="h-4 w-4 text-white" />
                            )}
                        </div>
                        <label className="ml-2 text-sm text-gray-700">Allow users to use voice input</label>
                        <div className="inline-flex items-center ml-1.5 cursor-help" title="When enabled, users can use their microphone to dictate messages instead of typing. When disabled, the microphone button will be hidden from the chat interface.">
                            <FontAwesomeIcon icon={faCircleInfo} className="h-3.5 w-3.5 text-gray-400" />
                        </div>
                    </div>
                </div>

                {/* Section 3: Instructions */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 mb-6">
                    <div className=" ml-2   flex items-center w-[98%]">
                     <h2 className="text-2xl font-bold mb-4">Instructions</h2>
                        <div className="flex-1"></div>
                        <button className="flex items-center mr-2.5 gap-2 px-4 py-2 bg-gray-200 text-black font-semibold rounded-lg hover:bg-black hover:text-white"  onClick={advancedPromptLibraryModal}>
                           Prompt Snippets
                        </button>
                    </div>
                    <textarea id="instructions" name="instructions" rows={10}  value={tempInstructions}  onChange={handleTempChange}
  onBlur={handleBlur} className="mt-3 ml-3 block w-[97%] p-2 border border-gray-300 rounded-lg shadow-sm focus:ring-0 focus:border-gray-500 focus:outline-none sm:text-sm"></textarea>
                    <div className="ml-2 mt-6 flex items-center w-[98%] justify-between">
                        <button className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-black font-semibold rounded-lg hover:bg-black hover:text-white"
                        onClick={PromptPreviewModal}>
                            Prompt Preview
                        </button>

                        <button className="flex items-center mr-2.5 gap-2 px-4 py-2 bg-white border border-gray-500   rounded-full text-black font-semibold hover:bg-black hover:text-white"
                        onClick={advancedAIModal} 
                        >
                            Advanced AI Settings
                        </button>
                    </div>
                </div>

             

                {/* Section 5: Knowledge */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-10 mb-6">
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-2xl font-bold mb-4 ">Knowledge</h2>
                        <div className="flex items-center">
                            <label className="flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={includeCommonKnowledge}
                                  onChange={handleCommonKnowledge}
                                  className="hidden"
                                />
                                <div
                                  className={`mr-2 h-6 w-6 border-2 border-gray-300 rounded-full flex items-center justify-center ${
                                    String(includeCommonKnowledge) === 'true' ? "bg-black" : "bg-white"
                                  }`}
                                >
                                  {String(includeCommonKnowledge) === 'true' && (
                                    <FontAwesomeIcon icon={faCheck} className="h-4 w-4 text-white" />
                                  )}
                                </div>
                                <span className="text-sm mr-1">Include Kellogg common knowledge</span>
                              </label>
                              <div className="relative group">
                                <span className="text-black">
                                  <FontAwesomeIcon icon={faQuestionCircle} className="h-4 w-4" />
                                </span>
                                <div className="absolute right-0 w-64 bg-white p-2 rounded shadow-lg border text-xs invisible group-hover:visible z-10">
                                  When enabled, responses will include information from common knowledge in addition to your added knowledge sources.
                                </div>
                              </div>
                            </div>
                        </div>
                             <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-bold mb-6 pb-3 border-b border-gray-200">Upload Files</h2>
                    <FileUploader
                    assistant={assistant}
                    onUploadComplete={handleUploadComplete} 
                    triggerAutoSave={triggerFileUploader}  // Pass the autoSave function
                    isCustomFileRNightly={isCustomFileRNightly} // Pass it here
                    setIsCustomFileRNightly={setIsCustomFileRNightly} // Pass the setter function here
                    isCustomFileFullLoad={isCustomFileFullLoad} // Pass it here
                    setIsCustomFileFullLoad={setIsCustomFileFullLoad} 
                    />
                </div>
                        <div className="grid grid-cols-1  grid-cols-2 lg:grid-cols-3 gap-5  ">

                                   {/* Public Websites Card */}
                          <div className="border rounded-lg shadow-sm p-4 tile-container flex flex-col justify-between" onClick={handlePublicWebsites}>
                                <div>
                                  <div className="flex items-center space-x-2">
                                      <FontAwesomeIcon icon={faGlobe} className="h-5 w-5 text-gray-600" />
                                      <h3 className="text-sm font-medium">Public Websites</h3>
                                  </div>
                                  <p className="pt-3 pl-7 text-gray-500 text-xs">Add data from public websites</p>
                                </div>
                                <div className="mt-6 ml-4 flex items-center justify-center h-7 w-12 text-1xl font-bold border border-gray-500 rounded-full"> 
                                  {websites.filter(website => website.connectionState === 'connected').length}</div>
                            </div>
                            {/* SharePoint Card - Add this to your existing grid in the Knowledge section */}
                 <div className="border rounded-lg shadow-sm p-4 tile-container flex flex-col justify-between" onClick={handleSharePoint}>
                              
                              <div>
                                <div className="flex items-center space-x-2">
                                  <img src="/sharepoint-logo.png" alt="SharePoint Logo" className="h-5 w-5" />
                                  <h3 className="text-sm font-medium">SharePoint</h3>
                                </div>
                                <p className="pt-3 pl-7 text-gray-500 text-xs">Add documents and files from SharePoint Sources</p>
                              </div>
                              
                              <div className="mt-6 ml-4 flex items-center justify-center h-7 w-12 text-1xl font-bold border border-gray-500 rounded-full">
                                {sharepoints.filter(sharepoint => sharepoint.connectionState === 'connected').length}
                              </div>
                              </div>
          
                            {/* Canvas Card */}
                            <div className="border rounded-lg shadow-sm p-4 tile-container flex flex-col justify-between" onClick={handleCanvasCourse}>
                            <div>
                              <div className="flex items-center space-x-2">
                                <img src="/canvas-logo.svg" alt="Canvas Logo" className="h-5 w-5" />
                                <h3 className="text-sm font-medium">Canvas</h3>
                              </div>
                              <p className="pt-3 pl-7 text-gray-500 text-xs">Add course content from a Canvas course site</p>
                            </div>

                            <div className="mt-6 ml-4 flex items-center justify-center h-7 w-12 text-1xl font-bold border border-gray-500 rounded-full">
                              {courses.filter(course => course.course_id !== '').length}
                            </div>
                          </div>


                            {/* Panopto Card */}
                            <div className="border rounded-lg shadow-sm p-4 tile-container flex flex-col justify-between" onClick={handlePanopto}>
                              <div>
                                <div className="flex items-center space-x-2">
                                    <img src="/panopto-logo.svg" alt="Panopto Logo" className="h-5 w-5" />
                                    <h3 className="text-sm font-medium">Panopto</h3>
                                </div>
                                <p className="pt-3 pl-7 text-gray-500 text-xs">Add video transcripts from a Panopto folder</p>
                              </div>
                              <div className="mt-6 ml-4 flex items-center justify-center h-7 w-12 text-1xl font-bold border border-gray-500 rounded-full">
                                  {panoptos.filter(panopto => panopto.panopto_id !== '').length}
                              </div>
                            </div>

                 

                            {/* Calendar Schedule Card */}
                            <div className="border rounded-lg shadow-sm p-4 tile-container" onClick={handleCalender}>
                                <div className="flex items-center space-x-2">
                                    <FontAwesomeIcon icon={faFileExcel} className="h-5 w-5 text-gray-600" />
                                    <h3 className="text-sm font-medium">Calendar Schedule</h3>
                                </div>
                                <p className="pt-3 pl-7 text-gray-500 text-xs">Use this section to upload any calendar schedule </p>
                                <div className="mt-6 ml-4 flex items-center justify-center h-7 w-12 text-1xl font-bold border border-gray-500 rounded-full">
                                  {selectedCalenderFiles?.length ?? 0}
                                </div>

                            </div>

                        </div>
                </div>
                        

                {/* Section 6: Authentication */}
                {!isFetching && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <AuthenticationSettings
                             isAuthenticationEnabled={settings.isAuthenticationEnabled}
                             canvasUserEnabled={settings.canvasUserEnabled}
                             localUserEnabled={settings.localUserEnabled}
                             socialLoginEnabled={settings.socialLoginEnabled}
                             everyOneEnabled={settings.everyOneEnabled}
                             canvas_users_excluded={settings.canvas_users_excluded} 
                             local_users_included={settings.local_users_included} 
                             onSettingsChange={handleSettingsChange}
                             courseIds={courseIds} // Pass the courseIds state
                             selectedSocialLogins={settings.selectedSocialLogins} 
                          />
                </div>
                )}
            </div>
            {/* Resizing Handle */}
    <div
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart} 
        className="resizable hidden lg:block"
    ><FontAwesomeIcon icon={faGripVertical} className="text-gray-500 w-[9px] cursor-col-resize" /></div>
            {/* Second container with 30% width */}
            <div className="flex flex-col flex-1 min-w-0 hidden md:block" style={{ flex: 1, minWidth: "300px", maxWidth: `${rightWidth}px` }} >
{/* Refresh Preview Button */}
<button
onClick={() => {
  const iframe = document.getElementById("iframeref") as HTMLIFrameElement;
  if (iframe) {
    iframe.src = iframe.src; // Reset src to force reload
  }
}}
className="p-1 bg-white text-black border rounded-full border-gray-500 font-semibold 
  hover:bg-black hover:text-white flex items-center space-x-2 
  absolute top-1 right-1 z-60 shadow-lg" // Position it on top
>
<FontAwesomeIcon icon={faRefresh} className="h-4 w-4" />
</button>
            <div className="flex-1  bg-gray-50 border border-gray-400 mb-10 md:mb-8 lg:mb-8" style={{ flex: 1, minWidth: "300px", maxWidth: `${rightWidth}px`}} >
            { bypasstoken && (
              <iframe
              id="iframeref"
                // src="http://localhost:4000/5cf53127-c224-4731-bab0-0e4464636b15"
                src={`${VA_URL}${assistant?.app_id}?preview=true&bypasstoken=${bypasstoken}`}
                width="100%" 
                height="780px" 
                style={{ border: "none" }}
                title="Embedded Page"
              ></iframe>
            )}
               </div>
            <div className="pb-6"></div>
            </div>

            {/* Modal */}
             
            {isChatOpen && (
                <>
                {/* Background overlay */}
                <div className="fixed inset-0 bg-black opacity-50 z-50"
                ></div>

                {/* Modal content */}
                <div className="fixed inset-0 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                    <h2 className="text-xl font-semibold mb-4">Usage Metrics</h2>
                    <p className="mb-4">We are in Comming soon.....</p>
                    <div className="flex justify-end space-x-4">
                        <button
                        onClick={() => closeUsageMetrics ()}
                        className="bg-gray-300 px-4 py-2 rounded-md"
                        >
                        Close
                        </button>
                    </div>
                    </div>
                </div>
                </>
            )}
             {/* Modal */}
             {isActionModalOPen && (
              <div
                id="actionModal"
                className="absolute right-0 w-[30%] h-[60%] bg-white border border-gray-200 rounded-lg shadow-2xl drop-shadow-xl z-10 overflow-y-auto"
              >
                {assistant?.app_id && (
                  <>
                   <div className="p-4 border-b border-gray-200">
                   { appPublishStatus !== 'PUBLISHED' && (
                   <div className="text-red-600 bg-red-100 border border-red-300 p-3 rounded-md text-center mb-4">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                        This chatbot has not been published yet! 
                      </div>
                   )}
                      <div className="mb-3">
                        <div className="text-sm font-bold ">APP ID</div>
                        <div className="flex items-center">
                        <textarea 
                          readOnly 
                          value={assistant?.app_id}
                          className="dropdown-input"
                          rows={1}

                        />
                          <button className="ml-4" onClick={() => handleCopyClipBoard(assistant?.app_id, "app_id")}>
                            <FontAwesomeIcon
                              icon={copiedField === "app_id" ? faCheck : faCopy}
                              className={`h-4 w-4 ${copiedField === "app_id" ? "text-green-500" : "text-gray-500 hover:text-gray-700"}`}
                            />
                          </button>
                        </div>
                      </div>
                      
                      <div className="mb-3" >
                        <div className="text-sm font-bold ">URL</div>
                          <div className="flex items-center">
                          <textarea 
                          readOnly 
                          value={localStorage.getItem("inference_url") + assistant?.id || ''}
                          className="dropdown-input"
                          rows={3}

                        />
                            <button className="ml-4" onClick={() => handleCopyClipBoard(localStorage.getItem("inference_url") + assistant?.id, "url")}>
                              <FontAwesomeIcon
                                icon={copiedField === "url" ? faCheck : faCopy}
                                className={`h-4 w-4 ${copiedField === "url" ? "text-green-500" : "text-gray-500 hover:text-gray-700"}`}
                              />
                            </button>
                          </div>
                    </div>
                    
                    <div className="mb-3">
                      <div className="text-sm font-bold">Embed</div>
                      <div className="flex items-center">
                        
                        <textarea
                          readOnly
                          value={iframeEmbedCode}
                          className="dropdown-input font-mono whitespace-pre text-xs"
                          rows={2}
                          wrap="off"

                        />
                        <button className="ml-4" onClick={() => handleCopyClipBoard(iframeEmbedCode, "embed")}>
                          <FontAwesomeIcon
                            icon={copiedField === "embed" ? faCheck : faCopy}
                            className={`h-4 w-4 ${copiedField === "embed" ? "text-green-500" : "text-gray-500 hover:text-gray-700"}`}
                          />
                        </button>
                      </div>
                    </div>

                    <div className="mb-1">
                      <div className="flex items-center">
                        <div className="text-sm font-bold">Embed JS</div>
                        <div className="relative group ml-1.5">
                          <span className="text-gray-400 cursor-help">
                            <FontAwesomeIcon icon={faCircleInfo} className="h-3.5 w-3.5" />
                          </span>
                          <div className="absolute left-0 top-full mt-1 w-64 bg-white p-2 rounded shadow-lg border text-xs invisible group-hover:visible z-10">
                            <div className="font-semibold mb-1">Available data-position options:</div>
                            <div>bottom-right</div>
                            <div>bottom-left</div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center">

                        <textarea
                          readOnly
                          value={jsEmbedCode}
                          className="dropdown-input font-mono whitespace-pre text-xs"
                          rows={2}
                          wrap="off"

                        />
                        <button className="ml-4" onClick={() => handleCopyClipBoard(jsEmbedCode, "embedjs")}>
                          <FontAwesomeIcon
                            icon={copiedField === "embedjs" ? faCheck : faCopy}
                            className={`h-4 w-4 ${copiedField === "embedjs" ? "text-green-500" : "text-gray-500 hover:text-gray-700"}`}
                          />
                        </button>
                      </div>
                    </div>
                    </div>

                    
                     {/* Button Actions */}
                     
                  <div className="grid grid-cols-2 gap-2 mt-3 m-2">
                      {isCurrentUserCoOwner && (
                        <button
                          onClick={() => handleDeleteVA()}
                          className="flex items-center justify-center px-4 py-2 text-sm font-medium text-red-600 border border-red-400 rounded-md hover:bg-red-100 transition"
                        >
                          <FontAwesomeIcon icon={faTrash} className="mr-2" />
                          Delete
                        </button>
                      )}

                      <button
                        onClick={() => handleClone()}
                        className="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition"
                      >
                        <FontAwesomeIcon icon={faClone} className="mr-2" />
                        Create Copy
                      </button>

                      <button
                        onClick={() => handleCopyAppUrl()}
                        className="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition"
                      >
                        <FontAwesomeIcon icon={faCopy} className="mr-2" />
                        Copy App URL
                      </button>

                      <button
                        onClick={() => handleExport()}
                        className="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition"
                      >
                        <FontAwesomeIcon icon={faFileExport} className="mr-2" />
                        Export
                      </button>

                      {isCurrentUserCoOwner && (
                        <button
                          onClick={() => handleCoOwner(assistant)}
                          className="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition col-span-2"
                        >
                          <FontAwesomeIcon icon={faShare} className="mr-2" />
                          Share
                        </button>
                      )}
                    </div>

                  </>
                )}
              </div>
            )}

        {/* Include the Custom Modal component */}
        <CustomModal
    isOpen={customModal.isOpen}
    onClose={() => {
      setCustomModal({ ...customModal, isOpen: false });
      setIsPublishOperationInProgress(false); // Re-enable autosave on modal close
    }}
    onConfirm={customModal.onConfirm}
    title={customModal.title}
    message={customModal.message}
    type={customModal.type}
  />

  <CoOwnerModal
          isOpen={isCoOwnerModalOpen}
          onClose={() => setIsCoOwnerModalOpen(false)}
          assistantId={selectedAppId}
          onSave={handleSaveCoOwners}
          initialSelectedUsers={selectedCoOwners}
        />
  <ChatHistory
    isChatHistoryModalOpen={isChatHistoryModalOpen}
    setIsChatHistoryModalOpen={setIsChatHistoryModalOpen}
    assistant={assistant} 
  />
  <UsageMetrics
    isUsageMetrcisModalOpen={isUsageMetricsModalOpen}
    setIsUsageMetricsModalOpen={setIsUsageMetricsModalOpen}
    assistant={assistant} 
    triggerAutoSave={() => {
      if(isInitialLoadDone)
        setHasChanges(true);
    }}
    isMetricsEmail={isMetricsEmail} // Pass it here
    setMetricsEmail={setMetricsEmail}
    metricsEmailAddress={metricsEmailAddress} // Pass it here
    setMetricsEmailAddress={setMetricsEmailAddress}
  />

        {/* Include the Advanced UISettings component */}
            <AdvancedUISettings
                isUIModalOpen={isUIModalOpen}
                setIsUIModalOpen={setIsUIModalOpen}
                bgColor={bgColor}
                setBgColor={(value) => handleChange(setBgColor, value)}
                fontColor={fontColor}
                setFontColor={(value) => handleChange(setFontColor, value)}
                iconColor={iconColor}
                setIconColor={(value) => handleChange(setIconColor, value)}
                isShowHeader={isShowHeader}
                setIsShowHeader={(value) => handleChange(setIsShowHeader, value)}
                headerColor={headerColor}
                setHeaderColor={(value) => handleChange(setHeaderColor, value)}
                logo={logo}
                setLogo={(value) => handleChange(setLogo, value)}
            />
            {/* Modal */}
            
            <AdvancedAISettings
                isAIModalOpen={isAIModalOpen}
                setIsAIModalOpen={setIsAIModalOpen}
                temperature={temperature}
                setTemperature={(value) => handleChange(setTemperature, value)}
                maximumLength={maximumLength}
                setMaximumLength={(value) => handleChange("maxLength",setMaximumLength, value)}
                stopSequences={stopSequences}
                setStopSequences={(value) => handleChange(setStopSequences, value)}
                topP={topP}
                setTopP={(value) => handleChange(setTopP, value)}
                fPenalty={fPenalty}
                setFPenalty={(value) => handleChange(setFPenalty, value)}
                pPenalty={pPenalty}
                setPPenalty={(value) => handleChange(setPPenalty, value)}
                temperatureConfig={temperatureConfig}
                maximumLengthConfig={maximumLengthConfig}
                topPConfig={topPConfig}
                fPenaltyConfig={fPenaltyConfig}
                pPenaltyConfig={pPenaltyConfig}
                modal={modal} 
                setModal={(value) => handleChange(setModal, value)}
                aiModels = {aiModels}
            />
            <PublicWebsites
                isWebsiteModalOpen={isWebsiteModalOpen}
                setWebsiteModalOpen={setWebisteModalOpen}
                websites={websites} 
                setWebsites={(value) => handleWebsiteChange(setWebsites, value)}
                updateExcludedItems={updateExcludedItems}
                assistant={assistant} 
                triggerAutoSave={triggerWebsiteSave}
                isWebsiteRNightly={isWebsiteRNightly} // Pass it here
                setIsWebsiteRNightly={setIsWebsiteRNightly} // Pass the setter function here
                isWebsiteFullLoad={isWebsiteFullLoad} // Pass it here
                setIsWebsiteFullLoad={setIsWebsiteFullLoad} // Pass the setter function here
            />
            <CanvasCourse
                isCanvasCourseModalOpen={isCanvasCourseModalOpen}
                setCanvasCourseModalOpen={setCanvasCourseModalOpen}
                courses={courses} 
                setCourses={(value) => handleCanvasChange(setCourses, value)}
                updateExcludedItems={updateExcludedItems}
                handleToggleChange={handleToggleChange}
                assistant={assistant} 
                triggerAutoSave={triggerCanvasSave}
                isCanvasRNightly={isCanvasRNightly} // Pass it here
                setIsCanvasRNightly={setIsCanvasRNightly} // Pass the setter function here
                isCanvasFullLoad={isCanvasFullLoad} // Pass it here
                setIsCanvasFullLoad={setIsCanvasFullLoad}
            />
            <Panopto
                isPanoptoModalOpen={isPanoptoModalOpen}
                setPanoptoModalOpen={setPanoptoModalOpen}
                panoptos={panoptos} 
                setPanoptos={(value) => handlePanoptoChange(setPanoptos, value)}
                updateExcludedItems={updatePanoptoExcludedItems}
                triggerAutoSave={handlePanoptoTrigger} 
                isPanoptoRNightly={isPanoptoRNightly} // Pass it here
                setIsPanoptoRNightly={setIsPanoptoRNightly} // Pass the setter function here
                assistant={assistant} 
                isPanoptoFullLoad={isPanoptoFullLoad} // Pass it here
                setIsPanoptoFullLoad={setIsPanoptoFullLoad}
            />
             <CalenderSchedule
                isCalenderModalOpen={isCalenderModalOpen}
                setCalenderModalOpen={setCalenderModalOpen}
                assistant={assistant}
                onUploadComplete={handleCalenderUploadComplete} 
                triggerAutoSave={triggerFileUploader}
            />
            {/* Modal */}
            {/* Include the Advanced AddFromPromptLIbrary component */}
            <AddFromPromptLibrary
                isPLibraryModalOpen={isPLibraryModalOpen}
                setIsPromptLibraryModalOpen={setIsPromptLibraryModalOpen}
            />
            {/* Modal */}
            {/* Include the Prompt Preview component */}
            <PromptPreview
                isPPreviewModalOpen={isPPreviewModalOpen}
                setIsPromptPreviewModalOpen={setIsPromptPreviewModalOpen}
                instructions={instructions}
                assistantId={assistant?.app_id}
            />
            {isSharePointModalOpen && (
              <SharePoint
                setSharePointModalOpen={setSharePointModalOpen}
                sharepoints={sharepoints}
                setSharepoints={(value) => handleSharePointChange(setSharepoints, value)}
                updateExcludedItems={updateSharePointExcludedItems}
                handleToggleChange={handleSharePointToggleChange}
                triggerAutoSave={() => {
                  if(isInitialLoadDone)
                    setHasChanges(true);
                }}
                isSharePointRNightly={isSharePointRNightly}
                setIsSharePointRNightly={setIsSharePointRNightly}
                assistant={assistant}
                isSharePointFullLoad={isSharePointFullLoad}
                setIsSharePointFullLoad={setIsSharePointFullLoad}
              />
            )}
        </div>
        {/* Form or other content */}
    </div>
);
};

export default BuildNewAssistant;
